import React, { useState, useEffect, useRef, use, useMemo, useCallback } from "react";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import {
  Drawer,
  Box,
  Typography,
  IconButton,
  useTheme,
  Tabs,
  Tab,
  Paper,
  Grid,
  Chip,
  Tooltip,
  CircularProgress,
  Select,
  MenuItem,
  SelectChangeEvent,
  TextField,
  Divider,
  Radio,
  RadioGroup,
  FormControlLabel,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  InputAdornment,
} from "@mui/material";
import {
  Close as CloseIcon,
  Info as InfoIcon,
  Download as DownloadIcon,
  Search as SearchIcon,
} from "@mui/icons-material";
import { FaExpandAlt, FaCompressAlt } from "react-icons/fa";
import moment from "moment";
import AgGridTable from "../table/AgGridTable";
import axiosInstance from "../../axios/axios";
import { ColDef, ICellRendererParams } from "ag-grid-community";
import * as echarts from "echarts";
import CveComplience from "../../pages/onPremises/cve/CveComplience";
import cisco_assets from "../../assets/cisco-assets.svg";
import arista_assets from "../../assets/arista-assets.svg";
import paloalto_assets from "../../assets/paloalto3_v4_light.svg";
import cisco_dark from "../../assets/cisco-white.svg";
import arista_dark from "../../assets/arista-white.svg";
import paloalto_dark from "../../assets/paloalto4_v4_dark.svg";
import juniperLogo from "../../assets/juniper.svg";
import sophosLogo from "../../assets/sophos.svg";
import sophos_dark from "../../assets/sophos-white.svg";
import aswlogo from "../../assets/baseVersion/aws.svg";
import aswdarklogo from "../../../src/assets/baseVersion/aws_white.svg";
import dell_logo from "../../assets/baseVersion/dell-seeklogo 2.svg";
import syrotech_light from "../../assets/syrotech_light.svg";
import syrotech_dark from "../../assets/syrotech_dark.svg";
import juniper_dark from "../../assets/juniper-white.svg";
import cyberResilienceViews from "../../assets/CyberResilienceViews.png";
import cyberResilienceViewsDark from "../../assets/cyber_resilience_dark.svg";
import Exclamation from "../../assets/Exclamation.png";
import verifiedImg from "../../assets/baseVersion/True_img.svg";
import notVerifiedImg from "../../assets/baseVersion/False_img.svg";
import chat_icon from "../../assets/chat_icon.svg";
import chat_send from "../../assets/chat_send.svg";
import { END_POINTS } from "../../shared";
import AssetComplianceReportDrawer from "./AssetComplianceReportDrawer";
import OnPremCircle from "../OnPremCircle";
import CircleChart from "../CircleChart";
import { useLocation, useNavigate } from "react-router-dom";
import ReactApexChart from "react-apexcharts";
import SkeletonLoader from "../../modules/dashboard/shared/skeleton_loader";
import Intelliscore from "../../assets/baseVersion/Intelliscore.svg";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import darklogo from "../../assets/Intelli_score_dark.svg";
import CVEDetailsPanel from "../cve/CVEDetailsPanel";
import CVEDetailsDrawer from "../cve/CVEDetailsDrawer";
import DetailsFlyout from "../../pages/SecurityPosture/Details-Flyout";
import Config_Tick from "../../assets/baseVersion/Config_Tick_img.svg";
import Failed_img from "../../assets/baseVersion/Config_Cancel_img.svg";
import fortinet_img from "../../assets/fortinet.svg";
import fortinet_scan_dark from "../../assets/fortinet-white-1.svg";
import ubuntu from "../../assets/ubuntu.svg";
import ubuntu_dark from "../../assets/ubuntu_dark.svg";
import ubuntu_light from "../../assets/ubuntu_white.svg";
import windows_light from "../../assets/baseVersion/Windows_light.svg"
import windows_dark from "../../assets/baseVersion/Windows_dark.svg"
import redhat_light from "../../assets/redhat_light.svg";
import redhat_dark from "../../assets/redhat_dark.svg";
import debian from "../../assets/debian.svg";
import debian_dark from "../../assets/debian_dark.svg";
import huawei_light from "../../assets/huawei-ar21 1.svg";
import mikrotik from "../../assets/mikrotik.svg";
import mikrotik_dark from "../../assets/mikrotik_dark.svg";
import huawei_dark from "../../assets/huawei-dark.svg";
import edgecore_logo from "../../assets/baseVersion/edgecore-logo.svg";
import tplink_light from "../../assets/baseVersion/TPLINK_Logo_2 1.svg";
import tplink_dark from "../../assets/baseVersion/TPLINK_Logo_dark.svg";
import apple_img from "../../assets/apple.svg";
import apple_dark from "../../assets/apple_dark.svg";

import { ROLES_CONTENT_PROPS } from "../../shared/constants/constant-data";
import useRolePermissions from "../../shared/hooks/useRolePermissions";
import { useDispatch } from "react-redux";
import {
  setSelectedRowID,
  setTabSelected,
} from "../../pages/SecurityPosture/TabSelection-slice";
import { setConfigDiffData } from "../../pages/onPremises/ConfigDiff/ConfigDiff-slice";
import AssetHistoryTable from "../../pages/onPremises/ConfigDiff/AssetHistoryTable";
import TrendsCard from "../../pages/onPremises/ConfigDiff/TrendsCard";
import AcceptedRisk_False from "../../assets/baseVersion/AcceptedRisk_False.svg";
import WhiteTooltip from "../WhiteTooltip";
import TimelineChart from "./TimelineChart";
import { toast } from "react-toastify";
import eventEmitter from "../utils/eventEmitter";
interface AssetData {
  cloud?: any;
  device_name: string;
  resource_name?: string;
  device_type: string;
  type?: string;
  vendor: string;
  region_name: string;
  cve: number;
  cve_last_modified: string;
  security_score?: number;
  last_scan?: string;
  vulnerability?: number;
  status?: number;
  id: string;
  criticality?: string;
  vulnerability_levels?: Array<{
    critical: number;
    high: number;
    medium: number;
    low: number;
  }>;
}

interface MisconfigurationData {
  paramter: string;
  vulnerability: string;
  accepted_risk: string;
  compliance: string;
}

interface SecurityScoreData {
  security_Score: number;
  total_score: number;
  passed_parameters: number;
  failed_parameters: number;
  total_parameters: number;
  actual_score: number;
  intelli_score: number;
  cve_score: number;
}

interface ComplianceData {
  status: number;
  message: string;
  data: {
    compliance_data: {
      [key: string]: number;
    };
  };
}

interface ChatResponse {
  status: number;
  message: string;
  data: {
    result: string;
  };
}

interface AssetDetailsDrawerProps {
  open: boolean;
  onClose: () => void;
  assetData: AssetData | null;
  isCloud: boolean;
  isMenu?: any;
  onReport?: () => void;
  isCve?: boolean;
  isV2?: boolean;
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`asset-tabpanel-${index}`}
      aria-labelledby={`asset-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 1 }}>{children}</Box>}
    </div>
  );
}

interface CVEData {
  cve_id: string;
  asset_count: number;
  description: string;
  cisas_kev: string;
  cisa_key?: string;
  epss: string;
  version: string;
  score: string;
  vector_string: string;
  severity: string;
  cvss_data: Array<{
    score: number;
    vector_string: string;
    severity: string;
    version: string;
  }>;
  cve_issued_date: string;
  cve_last_updated: string;
  summaryData?: any;
}

const getSeverityValue = (severity: string) => {
  switch (severity.toLowerCase()) {
    case "critical":
      return 4;
    case "high":
      return 3;
    case "medium":
      return 2;
    case "low":
      return 1;
    default:
      return 0;
  }
};

const AssetDetailsDrawer: React.FC<AssetDetailsDrawerProps> = ({
  open,
  onClose,
  assetData,
  isCloud,
  isMenu,
  isCve,
  isV2 = false,
}) => {
  const [tabValue, setTabValue] = useState(-1);
  const [isExpanded, setIsExpanded] = useState(false);
  const [cveData, setCveData] = useState<CVEData[]>([]);
  const [misconfigData, setMisconfigData] = useState<MisconfigurationData[]>(
    []
  );
  const [cveDrawerOpen, setCveDrawerOpen] = useState(false);
  const [misconfigDrawerOpen, setMisconfigDrawerOpen] = useState(false);

  const [selectedCVE, setSelectedCVE] = useState<CVEData | null>(null);
  const [selectedMisconfig, setSelectedMisconfig] = useState<any | null>(null);
  const [loading, setLoading] = useState(false);
  const [misconfigLoading, setMisconfigLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [securityScoreData, setSecurityScoreData] =
    useState<SecurityScoreData | null>(null);
  const [complianceData, setComplianceData] = useState<ComplianceData | null>(
    null
  );
  const [overAllvulnerbaility, setOverAllvulnerbaility] = useState<any>(null);
  const [overAllVulnerbailityTotal, setOverAllVulnerbailityTotal] =
    useState<any>(null);
  const [cveVulnerability, setCveVulnerability] = useState<any>(null);
  const [cyberGraphData, setCyberGraphData] = useState<any>(null);
  const [isChartLoading, setIsChartLoading] = useState(false);
  const postureChartRef = useRef<HTMLDivElement>(null);
  const cveChartRef = useRef<HTMLDivElement>(null);
  const timelineChartRef = useRef<HTMLDivElement>(null);
  const [timeRange, setTimeRange] = useState("7");
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const [chatDrawerOpen, setChatDrawerOpen] = useState(false);
  const [chatInput, setChatInput] = useState("");
  const [chatResponse, setChatResponse] = useState<ChatResponse>({
    status: 200,
    message: "Welcome",
    data: {
      result: "",
    },
  });
  const [isLoadingChat, setIsLoadingChat] = useState(false);
  const [isCveLoading, setIsCveLoading] = useState(false);
  const [reportDrawerOpen, setReportDrawerOpen] = useState(false);
  const [downloadModalOpen, setDownloadModalOpen] = useState(false);
  const [reportFormat, setReportFormat] = useState("pdf");
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [softwareData, setSoftwareData] = useState<any[]>([]);
  const [isSoftwareLoading, setIsSoftwareLoading] = useState<boolean>(false);
  const [usersData, setUsersData] = useState<any[]>([]);
  const [isUsersLoading, setIsUsersLoading] = useState<boolean>(false);
  const [credentialsData, setCredentialsData] = useState<any[]>([]);
  const [isCredentialsLoading, setIsCredentialsLoading] = useState<boolean>(false);
  const [summaryData, setSummaryData] = useState<any>(null);
  const [isSummaryLoading, setIsSummaryLoading] = useState<boolean>(false);
  const [historyData, setHistoryData] = useState<any[]>([]);
  const [isHistoryLoading, setIsHistoryLoading] = useState<boolean>(false);
  const [configDiffHistory, setConfigDiffHistory] = useState<any[]>([]);
  const [configDiffDetails, setConfigDiffDetails] = useState<any>(null);
  const [isConfigDiffLoading, setIsConfigDiffLoading] = useState<boolean>(false);
  const [configDiffPage, setConfigDiffPage] = useState(1);
  const [configDiffPageSize, setConfigDiffPageSize] = useState(10);
  const location = useLocation();
  const navigate = useNavigate();
  const isAssetV2 = isV2 || location.pathname.includes("asset_v2");
  const isDiscovery =
    assetData?.type?.toLowerCase() === "discovery" ||
    (assetData as any)?.scan_type?.toLowerCase() === "discovery";

  const v = ((assetData as any)?.vendor || "").toLowerCase();
  const m = ((assetData as any)?.model || "").toLowerCase();
  const os = ((assetData as any)?.os || (assetData as any)?.os_version || "").toLowerCase();
  const isMicrosoftOrWindows = v.includes("microsoft") || v.includes("windows") || m.includes("windows") || os.includes("windows") || os.includes("microsoft");
  const isAppleOrMac = v.includes("apple") || v.includes("mac") || m.includes("mac") || os.includes("mac") || os.includes("apple");
  const showSoftwareInfo = isMicrosoftOrWindows || isAppleOrMac;
  const getDefaultTabValue = useCallback(() => {
    if (isAssetV2) {
      return isCloud ? 0 : -1;
    }
    return 0;
  }, [isAssetV2, isCloud]);
  const { hasPermissions } = useRolePermissions();

  const fetchSoftwareData = useCallback(async () => {
    if (!assetData) return;
    const ip = (assetData as any)?.ip_address || (assetData as any)?.ip || assetData?.device_name || assetData?.resource_name;
    if (!ip) return;

    setIsSoftwareLoading(true);
    try {
      const userDetails = JSON.parse(localStorage.getItem("userDetails") || "{}");
      const organizationId = (assetData as any)?.organization_id || userDetails?.organization_id;

      const params: any = { ip };
      if (organizationId) params.organization_id = organizationId;

      const response = await axiosInstance.get<any>(
        END_POINTS.WMI_SOFTWARE_BY_IP,
        { params }
      );

      if (response.status === 200 && response.data) {
        const rawGrouped =
          response.data?.grouped_results ||
          response.data?.data?.grouped_results ||
          [];
        const rawResults =
          response.data?.results ||
          response.data?.data?.results ||
          response.data?.software ||
          response.data?.data?.software ||
          (Array.isArray(response.data) ? response.data : []);

        let flattenedResults = [];
        if (rawGrouped && rawGrouped.length > 0) {
          flattenedResults = rawGrouped.flatMap((g: any) => g.softwares || []);
        } else {
          flattenedResults = rawResults;
        }

        const rawTransformed = (flattenedResults || []).map((item: any) => {
          let formattedDate = "-";
          const rawDate = item.detected_date || item.first_detected || item.last_detected || item.installed_on || item.installed_date || item.created_at;
          if (rawDate) {
            const d = new Date(rawDate);
            if (!isNaN(d.getTime())) {
              formattedDate = d.toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              });
            } else {
              formattedDate = rawDate;
            }
          }

          return {
            ...item,
            raw_date: rawDate,
            name: item.name || item.software_name || "-",
            version: item.version || "-",
            vendor: item.vendor || item.publisher || "-",
            detected_date: formattedDate,
          };
        });

        rawTransformed.sort((a: any, b: any) => {
          const timeA = a.raw_date ? new Date(a.raw_date).getTime() : 0;
          const timeB = b.raw_date ? new Date(b.raw_date).getTime() : 0;
          const validA = isNaN(timeA) ? 0 : timeA;
          const validB = isNaN(timeB) ? 0 : timeB;
          if (validA !== validB) return validB - validA;
          return (a.name || "").localeCompare(b.name || "");
        });

        let globalIndex = 0;
        const transformedData = rawTransformed.map((item: any) => ({
          ...item,
          serialNumber: ++globalIndex,
        }));

        setSoftwareData(transformedData);
      }
    } catch (error) {
      console.error("Error fetching software by IP:", error);
      setSoftwareData([]);
    } finally {
      setIsSoftwareLoading(false);
    }
  }, [assetData]);

  const fetchDeviceOwnerData = useCallback(async (moduleType: "users" | "credentials") => {
    if (!assetData) return;
    const deviceId = (assetData as any)?.id || (assetData as any)?.asset_id || (assetData as any)?._id || (assetData as any)?.device_id;
    if (!deviceId) return;

    if (moduleType === "users") setIsUsersLoading(true);
    else setIsCredentialsLoading(true);

    try {
      const payload = {
        device_id: Array.isArray(deviceId) ? deviceId : [String(deviceId)],
        module: moduleType,
        ...(moduleType === "users" && isV2
          ? { device_type: (assetData as any)?.type || assetData?.device_type }
          : {}),
      };

      const response = await axiosInstance.post<any>(
        END_POINTS.DEVICE_OWNER_BY_ID,
        payload
      );

      if (response.status === 200 && response.data) {
        if (moduleType === "users") {
          const rawList =
            response.data?.data?.user_details ||
            response.data?.user_details ||
            response.data?.data?.details ||
            (Array.isArray(response.data?.data) ? response.data.data : (Array.isArray(response.data) ? response.data : []));

          let index = 0;
          const transformed = (rawList || []).map((item: any) => {
            const fullName = (item.name || `${item.firstname || ""} ${item.lastname || ""}`).trim();
            const displayName = fullName || item.email?.split("@")[0] || item.username || "-";

            let formattedLastLoggedIn = "-";
            const rawLastLoggedIn = item.last_logged_in || item.last_used_date || item.last_logged_in_time;
            if (rawLastLoggedIn) {
              const d = new Date(rawLastLoggedIn);
              if (!isNaN(d.getTime())) {
                formattedLastLoggedIn = d.toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                }) + ", " + d.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });
              } else {
                formattedLastLoggedIn = rawLastLoggedIn;
              }
            }

            let formattedCreatedTime = "-";
            const rawCreatedTime = item.created_time || item.created_at;
            if (rawCreatedTime) {
              const d = new Date(rawCreatedTime);
              if (!isNaN(d.getTime())) {
                formattedCreatedTime = d.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });
              } else {
                formattedCreatedTime = rawCreatedTime;
              }
            }

            return {
              ...item,
              serialNumber: ++index,
              name: displayName,
              email: item.email || "-",
              profile: item.last_used_status || item.profile || "Active",
              last_logged_in: formattedLastLoggedIn,
              created_time: formattedCreatedTime,
            };
          });

          setUsersData(transformed);
        } else {
          const rawList =
            response.data?.data?.credential_details ||
            response.data?.credential_details ||
            response.data?.data?.credentials_details ||
            response.data?.credentials_details ||
            response.data?.data?.details ||
            (Array.isArray(response.data?.data) ? response.data.data : (Array.isArray(response.data) ? response.data : []));

          let index = 0;
          const transformed = (rawList || []).map((item: any) => {
            const formatDateTime = (raw: any) => {
              if (!raw) return "-";
              const d = new Date(raw);
              if (isNaN(d.getTime())) return raw;
              return d.toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              }) + ", " + d.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });
            };

            return {
              ...item,
              serialNumber: ++index,
              name: item.cred_name || item.name || "-",
              type: item.credential_type || item.type || "-",
              last_used: formatDateTime(item.last_used),
              last_used_status: item.last_used_status || "-",
              last_success_time: formatDateTime(item.last_success_time),
            };
          });

          setCredentialsData(transformed);
        }
      }
    } catch (error) {
      console.error(`Error fetching ${moduleType} data:`, error);
      if (moduleType === "users") setUsersData([]);
      else setCredentialsData([]);
    } finally {
      if (moduleType === "users") setIsUsersLoading(false);
      else setIsCredentialsLoading(false);
    }
  }, [assetData, isV2]);

  const fetchSummaryData = useCallback(async () => {
    if (!assetData) return;
    const deviceId = (assetData as any)?.id || (assetData as any)?.asset_id || (assetData as any)?._id || (assetData as any)?.device_id;
    if (!deviceId) return;

    setIsSummaryLoading(true);
    try {
      const payload = {
        device_id: Array.isArray(deviceId) ? deviceId : [String(deviceId)],
        module: "discovery-posture",
      };

      const response = await axiosInstance.post<any>(
        END_POINTS.DEVICE_OWNER_BY_ID,
        payload
      );

      if (response.status === 200 && response.data?.data?.discovery_posture) {
        setSummaryData(response.data.data.discovery_posture);
      }
    } catch (error) {
      console.error("Error fetching summary data:", error);
      setSummaryData(null);
    } finally {
      setIsSummaryLoading(false);
    }
  }, [assetData]);

  const fetchHistoryData = useCallback(async () => {
    if (!assetData) return;
    const deviceId = (assetData as any)?.id || (assetData as any)?.asset_id || (assetData as any)?._id || (assetData as any)?.device_id;
    if (!deviceId) return;

    setIsHistoryLoading(true);
    try {
      const payload = {
        device_uuid: Array.isArray(deviceId) ? String(deviceId[0]) : String(deviceId),
      };

      const response = await axiosInstance.post<any>(
        END_POINTS.CYBERRESILIENCE_DASHBOARD_DAILY,
        payload
      );

      if (response.status === 200 && response.data?.data?.event_data) {
        let globalIndex = 0;
        const formattedData = response.data.data.event_data.map((item: any) => ({
          ...item,
          serialNumber: ++globalIndex
        }));
        setHistoryData(formattedData);
      }
    } catch (error) {
      console.error("Error fetching history data:", error);
      setHistoryData([]);
    } finally {
      setIsHistoryLoading(false);
    }
  }, [assetData]);

  const fetchConfigDiffHistory = useCallback(async () => {
    if (!assetData) return;
    const deviceId = (assetData as any)?.id || (assetData as any)?.asset_id || (assetData as any)?._id || (assetData as any)?.device_id;
    if (!deviceId) return;
    const id = Array.isArray(deviceId) ? String(deviceId[0]) : String(deviceId);

    setIsConfigDiffLoading(true);
    try {
      try {
        const detailResp = await axiosInstance.get(END_POINTS.ASSET_CONFIG_DIFF, {
          params: { asset_id: id },
        });
        setConfigDiffDetails(detailResp?.data?.data || null);
      } catch (detailError) {
        console.error("Error fetching config diff asset details:", detailError);
        setConfigDiffDetails(null);
      }

      const resp = await axiosInstance.get(
        `${END_POINTS.ASSET_CONFIG_DIFF_HISTORY}/${id}/history`,
        { params: { page: configDiffPage, page_size: configDiffPageSize } }
      );
      const data = resp?.data?.data || resp?.data;
      const results = Array.isArray(data?.results)
        ? data.results
        : Array.isArray(data)
          ? data
          : [];

      const endDate = moment().format("YYYY-MM-DD");
      const startDate = moment().subtract(1, "year").format("YYYY-MM-DD");
      let scanDates: any[] = [];
      try {
        const datesResp = await axiosInstance.post(
          END_POINTS.DEVICE_CYBER_RESILIENCE_SCAN_DATES,
          { device_id: id, duration: "custom_date_range", start_date: startDate, end_date: endDate }
        );
        if (datesResp?.status === 200 && datesResp?.data?.data?.length > 0) {
          scanDates = datesResp.data.data;
        }
      } catch (dateError) {
        console.error("Error fetching config diff scan dates:", dateError);
      }

      const merged = results.map((item: any) => {
        const matchedScan = scanDates.find((scan: any) => scan.id === item.id);
        return {
          ...item,
          file_id: matchedScan?.file_id,
          date_added: matchedScan?.date_added,
          security_score: matchedScan?.security_score,
        };
      });
      const withPrevious = merged.map((item: any, index: number) => ({
        ...item,
        previous_file: merged[index + 1] || null,
      }));
      setConfigDiffHistory(withPrevious);
    } catch (error) {
      console.error("Error fetching config diff history:", error);
      setConfigDiffHistory([]);
    } finally {
      setIsConfigDiffLoading(false);
    }
  }, [assetData, configDiffPage, configDiffPageSize]);

  useEffect(() => {
    if (open) {
      setSoftwareData([]);
      setUsersData([]);
      setCredentialsData([]);
      setSummaryData(null);
      setHistoryData([]);
      setConfigDiffHistory([]);
      setConfigDiffDetails(null);
      setConfigDiffPage(1);
    }
  }, [open, assetData]);

  useEffect(() => {
    if (open && assetData) {
      // Fetch these immediately so their counts can be shown in the tabs
      // They don't depend on tabValue so they only run once when the drawer opens
      fetchSoftwareData();
      fetchDeviceOwnerData("users");
      fetchDeviceOwnerData("credentials");
    }
  }, [open, assetData, fetchSoftwareData, fetchDeviceOwnerData]);

  useEffect(() => {
    if (open && assetData) {
      // Fetch summary and history only when their tabs are active
      if (tabValue === -1) {
        fetchSummaryData();
      }
      if (tabValue === 104) {
        fetchHistoryData();
      }
      if (tabValue === 99) {
        fetchConfigDiffHistory();
      }
    }
  }, [open, assetData, tabValue, fetchSummaryData, fetchHistoryData, fetchConfigDiffHistory]);

  const softwareColumnDefs: ColDef[] = useMemo(() => [
    {
      field: "serialNumber",
      headerName: "#",
      width: 60,
      minWidth: 50,
      sortable: true,
      filter: false,
      cellRenderer: (params: ICellRendererParams) => (
        <Typography
          variant="body2"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            fontWeight: 500,
            fontSize: "12px",
            color: theme.palette.mode === "dark" ? "#9CA3AF" : "#475467",
            textAlign: "center",
          }}
        >
          {params.value || (params.node?.rowIndex !== undefined ? params.node.rowIndex + 1 : "-")}
        </Typography>
      ),
    },
    {
      field: "name",
      headerName: "Name",
      minWidth: 180,
      flex: 1.2,
      sortable: true,
      filter: true,
      cellRenderer: (params: ICellRendererParams) => (
        <WhiteTooltip title={params.value || "-"} arrow placement="bottom">
          <Typography
            variant="body2"
            sx={{
              display: "flex",
              alignItems: "center",
              height: "100%",
              fontWeight: 700,
              fontSize: "12px",
              color: theme.palette.mode === "dark" ? "#E5E7EB" : "#101828",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {params.value || "-"}
          </Typography>
        </WhiteTooltip>
      ),
    },
    {
      field: "version",
      headerName: "Version",
      minWidth: 150,
      flex: 1,
      sortable: true,
      filter: true,
      cellRenderer: (params: ICellRendererParams) => (
        <WhiteTooltip title={params.value || "-"} arrow placement="bottom">
          <Typography
            variant="body2"
            sx={{
              display: "flex",
              alignItems: "center",
              height: "100%",
              fontWeight: 500,
              fontSize: "12px",
              color: theme.palette.mode === "dark" ? "#9CA3AF" : "#475467",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {params.value || "-"}
          </Typography>
        </WhiteTooltip>
      ),
    },
    {
      field: "vendor",
      headerName: "Vendor",
      minWidth: 180,
      flex: 1.1,
      sortable: true,
      filter: true,
      cellRenderer: (params: ICellRendererParams) => (
        <WhiteTooltip title={params.value || "-"} arrow placement="bottom">
          <Typography
            variant="body2"
            sx={{
              display: "flex",
              alignItems: "center",
              height: "100%",
              fontWeight: 500,
              fontSize: "12px",
              color: theme.palette.mode === "dark" ? "#9CA3AF" : "#475467",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {params.value || "-"}
          </Typography>
        </WhiteTooltip>
      ),
    },
    {
      field: "detected_date",
      headerName: "Detected Date",
      minWidth: 140,
      flex: 0.9,
      sortable: true,
      filter: true,
      comparator: (dateA: any, dateB: any) => {
        const timeA = dateA && dateA !== "-" ? new Date(dateA).getTime() : 0;
        const timeB = dateB && dateB !== "-" ? new Date(dateB).getTime() : 0;
        const validA = isNaN(timeA) ? 0 : timeA;
        const validB = isNaN(timeB) ? 0 : timeB;
        return validA - validB;
      },
      cellRenderer: (params: ICellRendererParams) => (
        <Typography
          variant="body2"
          sx={{
            display: "flex",
            alignItems: "center",
            height: "100%",
            fontWeight: 500,
            fontSize: "12px",
            color: theme.palette.mode === "dark" ? "#9CA3AF" : "#475467",
          }}
        >
          {params.value || "-"}
        </Typography>
      ),
    },
  ], [theme.palette.mode]);

  const historyColumnDefs: ColDef[] = useMemo(() => [
    {
      field: "event_name",
      headerName: "Event Name",
      minWidth: 140,
      flex: 1,
      sortable: true,
      filter: true,
      cellRenderer: (params: ICellRendererParams) => (
        <WhiteTooltip title={params.value || "-"} arrow placement="bottom">
          <Typography
            variant="body2"
            sx={{
              display: "flex",
              alignItems: "center",
              height: "100%",
              fontWeight: 700,
              fontSize: "12px",
              color: theme.palette.mode === "dark" ? "#E5E7EB" : "#101828",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {params.value || "-"}
          </Typography>
        </WhiteTooltip>
      ),
    },
    {
      field: "event_code",
      headerName: "Source",
      minWidth: 110,
      flex: 0.8,
      sortable: true,
      filter: true,
      cellRenderer: (params: ICellRendererParams) => (
        <Typography
          variant="body2"
          sx={{
            display: "flex",
            alignItems: "center",
            height: "100%",
            fontWeight: 500,
            fontSize: "12px",
            color: theme.palette.mode === "dark" ? "#E5E7EB" : "#101828",
          }}
        >
          {params.value || "-"}
        </Typography>
      ),
    },
    {
      field: "scan_type",
      headerName: "Scan Type",
      minWidth: 130,
      flex: 0.9,
      sortable: true,
      filter: true,
      cellRenderer: (params: ICellRendererParams) => (
        <WhiteTooltip title={params.value || "-"} arrow placement="bottom">
          <Typography
            variant="body2"
            sx={{
              display: "flex",
              alignItems: "center",
              height: "100%",
              fontWeight: 500,
              fontSize: "12px",
              color: theme.palette.mode === "dark" ? "#E5E7EB" : "#101828",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {params.value || "-"}
          </Typography>
        </WhiteTooltip>
      ),
    },
    {
      field: "agent_name",
      headerName: "Agent",
      minWidth: 120,
      flex: 0.8,
      sortable: true,
      filter: true,
      cellRenderer: (params: ICellRendererParams) => (
        <WhiteTooltip title={params.value || "-"} arrow placement="bottom">
          <Typography
            variant="body2"
            sx={{
              display: "flex",
              alignItems: "center",
              height: "100%",
              fontWeight: 500,
              fontSize: "12px",
              color: theme.palette.mode === "dark" ? "#E5E7EB" : "#101828",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {params.value || "-"}
          </Typography>
        </WhiteTooltip>
      ),
    },
    {
      field: "event_date",
      headerName: "Date",
      minWidth: 160,
      flex: 1.1,
      sortable: true,
      filter: true,
      comparator: (dateA: any, dateB: any) => {
        const timeA = dateA ? moment.utc(dateA).valueOf() : 0;
        const timeB = dateB ? moment.utc(dateB).valueOf() : 0;
        return timeA - timeB;
      },
      cellRenderer: (params: ICellRendererParams) => {
        if (!params.value) return "-";
        const date = moment.utc(params.value).utcOffset("+05:30");
        return (
          <Typography
            variant="body2"
            sx={{
              display: "flex",
              alignItems: "center",
              height: "100%",
              fontWeight: 500,
              fontSize: "12px",
              color: theme.palette.mode === "dark" ? "#E5E7EB" : "#101828",
            }}
          >
            {date.isValid()
              ? date.format("DD-MMMM-YYYY HH:mm:ss")
              : params.value}
          </Typography>
        );
      },
    }
  ], [theme.palette.mode]);

  const userOwnerColumnDefs: ColDef[] = useMemo(() => [
    {
      field: "name",
      headerName: "Name",
      minWidth: 160,
      flex: 1,
      sortable: true,
      filter: true,
      cellRenderer: (params: ICellRendererParams) => (
        <WhiteTooltip title={params.value || "-"} arrow placement="bottom">
          <Typography
            variant="body2"
            sx={{
              display: "flex",
              alignItems: "center",
              height: "100%",
              fontWeight: 700,
              fontSize: "12px",
              color: theme.palette.mode === "dark" ? "#E5E7EB" : "#101828",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {params.value || "-"}
          </Typography>
        </WhiteTooltip>
      ),
    },
    {
      field: "email",
      headerName: "Email",
      minWidth: 200,
      flex: 1.2,
      sortable: true,
      filter: true,
      cellRenderer: (params: ICellRendererParams) => (
        <WhiteTooltip title={params.value || "-"} arrow placement="bottom">
          <Typography
            variant="body2"
            sx={{
              display: "flex",
              alignItems: "center",
              height: "100%",
              fontWeight: 500,
              fontSize: "12px",
              color: theme.palette.mode === "dark" ? "#9CA3AF" : "#475467",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {params.value || "-"}
          </Typography>
        </WhiteTooltip>
      ),
    },
    {
      field: "profile",
      headerName: "Profile",
      minWidth: 120,
      flex: 0.8,
      sortable: true,
      filter: true,
      cellRenderer: (params: ICellRendererParams) => (
        <Typography
          variant="body2"
          sx={{
            display: "flex",
            alignItems: "center",
            height: "100%",
            fontWeight: 600,
            fontSize: "12px",
            color:
              String(params.value).toLowerCase() === "active"
                ? "#16A34A"
                : theme.palette.mode === "dark"
                ? "#9CA3AF"
                : "#475467",
          }}
        >
          {params.value || "-"}
        </Typography>
      ),
    },
  ], [theme.palette.mode]);

  const credentialsColumnDefs: ColDef[] = useMemo(() => [
    {
      field: "name",
      headerName: "Name",
      minWidth: 160,
      flex: 1,
      sortable: true,
      filter: true,
      cellRenderer: (params: ICellRendererParams) => (
        <WhiteTooltip title={params.value || "-"} arrow placement="bottom">
          <Typography
            variant="body2"
            sx={{
              display: "flex",
              alignItems: "center",
              height: "100%",
              fontWeight: 700,
              fontSize: "12px",
              color: theme.palette.mode === "dark" ? "#E5E7EB" : "#101828",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {params.value || "-"}
          </Typography>
        </WhiteTooltip>
      ),
    },
    {
      field: "type",
      headerName: "Type",
      minWidth: 120,
      flex: 0.8,
      sortable: true,
      filter: true,
      cellRenderer: (params: ICellRendererParams) => (
        <Typography
          variant="body2"
          sx={{
            display: "flex",
            alignItems: "center",
            height: "100%",
            fontWeight: 500,
            fontSize: "12px",
            color: theme.palette.mode === "dark" ? "#9CA3AF" : "#475467",
          }}
        >
          {params.value || "-"}
        </Typography>
      ),
    },
    {
      field: "last_used",
      headerName: "Last Used",
      minWidth: 180,
      flex: 1.1,
      sortable: true,
      filter: true,
      cellRenderer: (params: ICellRendererParams) => (
        <Typography
          variant="body2"
          sx={{
            display: "flex",
            alignItems: "center",
            height: "100%",
            fontWeight: 500,
            fontSize: "12px",
            color: theme.palette.mode === "dark" ? "#9CA3AF" : "#475467",
          }}
        >
          {params.value || "-"}
        </Typography>
      ),
    },
    {
      field: "last_used_status",
      headerName: "Last Used Status",
      minWidth: 150,
      flex: 1,
      sortable: true,
      filter: true,
      cellRenderer: (params: ICellRendererParams) => (
        <Typography
          variant="body2"
          sx={{
            display: "flex",
            alignItems: "center",
            height: "100%",
            fontWeight: 600,
            fontSize: "12px",
            color:
              String(params.value).toLowerCase() === "active"
                ? "#16A34A"
                : theme.palette.mode === "dark"
                ? "#9CA3AF"
                : "#475467",
          }}
        >
          {params.value || "-"}
        </Typography>
      ),
    },
    {
      field: "last_success_time",
      headerName: "Last Success Time",
      minWidth: 180,
      flex: 1.1,
      sortable: true,
      filter: true,
      cellRenderer: (params: ICellRendererParams) => (
        <Typography
          variant="body2"
          sx={{
            display: "flex",
            alignItems: "center",
            height: "100%",
            fontWeight: 500,
            fontSize: "12px",
            color: theme.palette.mode === "dark" ? "#9CA3AF" : "#475467",
          }}
        >
          {params.value || "-"}
        </Typography>
      ),
    },
  ], [theme.palette.mode]);

  const handleShowConfigDiff = () => {
    if (!assetData?.id) return;
    dispatch(
      setConfigDiffData({
        rowData: assetData,
        device_id: String(assetData.id),
        click: "assets",
      })
    );
    onClose();
    navigate("/on-premises/configdiff", {
      state: { device_id: String(assetData.id) },
    });
  };
  // let module = "";
  const customSortOrder = ["Critical", "High", "Medium", "Low"];
  //const location = useLocation();
  console.log(location.pathname, "location.pathname");
  // if (location.pathname.includes("on-premises/assets")) {
  //   module = "on_premise";
  // } else {
  //   module = "cloud";
  // }
  console.log("assests", assetData);
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
    setCveDrawerOpen(false);
    setMisconfigDrawerOpen(false);
  };
  const getMetricsFromSummary = () => {
    // if (!cveData.summaryData?.vulnerability_details) return mockChips;
    // const vd = cveData.summaryData.vulnerability_details;
    // return [
    //   { label: vd.attack_vector, color: "#DC2626" },
    //   { label: vd.attack_complexity, color: "#22C55E" },
    //   { label: vd.privileges_required, color: "#3B82F6" },
    //   { label: vd.user_interaction, color: "#F97316" },
    //   { label: vd.scope, color: "#6B7280" },
    // ];
    const array: any = [];
    if (selectedCVE?.cisas_kev) {
      array.push({
        label: "CISA's Known Exploited Vulnerabilities",
        color: "#DC2626",
        showDot: false,
      });
    }
    return array;
  };

  const chips = getMetricsFromSummary();

  const dispatch = useDispatch();

  const fetchCVEData = async () => {
    if (!assetData) return;

    try {
      setLoading(true);
      const payload: any = {
        type: 1,
        asset_list: [assetData.id],
      };
      if (isCloud) {
        payload.module = "cloud";
      } else {
        payload.module = "on_premise";
      }
      const response = await axiosInstance.post(
        "securityscan/cve/search_cve",
        payload
      );
      if (response.data.status === 200) {
        let indexes = response.data.data.cve_list || [];
        indexes = sortDataByVulnerability(indexes); // sort after fetch
        setCveData(indexes);
        //setCveData(response.data.data.cve_list);
      }
    } catch (error) {
      console.error("Error fetching CVE data:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleMisconfigClick = async (misconfigData: any) => {
    setMisconfigDrawerOpen(true);
    setSelectedMisconfig(misconfigData);
    dispatch(setTabSelected(2));

    dispatch(setSelectedRowID(misconfigData.id));

    console.log(misconfigData, "rowData");
  };
  const handleCVEClick = async (cveData: any) => {
    console.log(cveData, "rowData");
    setCveDrawerOpen(true);
    setSelectedCVE(cveData);
    setIsCveLoading(true);
    try {
      const payload = { cve: cveData.cve_id };
      const response = await axiosInstance.post(
        "securityscan/cve/cve_summary",
        payload
      );

      if (response.data.status === 200) {
        setSelectedCVE({
          ...cveData,
          summaryData: response.data.data.cve_summary_details,
        });
        console.log(
          response.data.data.cve_summary_details,
          "cve_summary_details"
        );
        setIsCveLoading(false);
      }
    } catch (error) {
      console.error("Error fetching CVE summary:", error);
      setIsCveLoading(false);
    } finally {
      setIsCveLoading(false);
    }
  };

  const fetchMisconfigData = async () => {
    if (!assetData) return;

    try {
      setMisconfigLoading(true);
      const payload: any = {
        type: 1,
        device_uuid: assetData.id,
      };
      if (isCloud) {
        payload.module = "cloud";
      } else {
        payload.module = "on_premise";
      }
      const response = await axiosInstance.post(
        "securityscan/asset-vulnerabilities",
        payload
      );
      if (response.data.status === 200) {
        let indexes = response.data.data.indexes || [];
        indexes = sortDataByVulnerability(indexes); // sort after fetch
        setMisconfigData(indexes);
        //setMisconfigData(response.data.data.indexes || []);
      }
    } catch (error) {
      console.error("Error fetching misconfiguration data:", error);
    } finally {
      setMisconfigLoading(false);
    }
  };
  const sortDataByVulnerability = (data: any) => {
    const sorted = [...data].sort((a, b) => {
      const severityA = a.severity?.toLowerCase() || "";
      const severityB = b.severity?.toLowerCase() || "";

      const orderA = customSortOrder.findIndex(
        (order: any) => order.toLowerCase() === severityA
      );
      const orderB = customSortOrder.findIndex(
        (order: any) => order.toLowerCase() === severityB
      );

      return orderA - orderB;
    });

    return sorted;
  };

  const fetchSecurityScore = async () => {
    if (!assetData) return;

    try {
      const ENDPOINT = isCloud
        ? `securityscan/dashboard-security-score?module=cloud&device_uuid=${assetData.id}`
        : `securityscan/dashboard-security-score?module=on_premise&device_uuid=${assetData.id}`;
      const response = await axiosInstance.get(ENDPOINT);
      if (response.data.status === 200) {
        setSecurityScoreData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching security score:", error);
    }
  };

  const fetchComplianceData = async () => {
    if (!assetData) return;

    try {
      const ENDPOINT = isCloud
        ? `securityscan/asset-compliance-summary?module=cloud&device_uuid=${assetData.id}`
        : `securityscan/asset-compliance-summary?module=on_premise&device_uuid=${assetData.id}`;
      const response = await axiosInstance.get(ENDPOINT);
      if (response.data.status === 200) {
        setComplianceData(response.data);
      }
    } catch (error) {
      console.error("Error fetching compliance data:", error);
    }
  };

  const fetchOverAllVulnerabilities = async () => {
    if (!assetData) return;

    try {
      const ENDPOINT = isCloud
        ? `securityscan/dashboard-overall-vulnerabilities?module=cloud&device_uuid=${assetData.id}`
        : `securityscan/dashboard-overall-vulnerabilities?module=on_premise&device_uuid=${assetData.id}`;
      const response = await axiosInstance.get(ENDPOINT);
      if (response.data.status === 200) {
        // setOverAllvulnerbaility(response?.data?.data);
        if (isCloud) {
          // const customCounts:any = {
          //     Critical: 0,
          //     High: 0,
          //     Medium: 0,
          //     Low: 0
          //   };
          const result: any = {};

          const cloud_vul =
            response?.data?.data?.misconfigurations?.cloud?.vulnerabilities;
          let total_count = 0;
          cloud_vul.forEach((vul: any) => {
            const key = vul.vulnerabilities_name.toLowerCase();
            result[key] = vul.count || 0;
            total_count += vul.count || 0;
          });
          setOverAllvulnerbaility(result);
          setOverAllVulnerbailityTotal(total_count);
        } else {
          // const customCounts:any = {
          //     Critical: 0,
          //     High: 0,
          //     Medium: 0,
          //     Low: 0
          //   };
          const result: any = {};
          const on_premise_vul =
            response?.data?.data?.misconfigurations?.on_premise
              ?.vulnerabilities;
          const total_count =
            response?.data?.data?.misconfigurations?.on_premise?.total_count;
          on_premise_vul.forEach((vul: any) => {
            const key = vul.vulnerabilities_name.toLowerCase();
            result[key] = vul.count || 0;
          });

          setOverAllvulnerbaility(result);
          if (typeof total_count === "undefined") {
            // If total_count is undefined, sum all values in result
            const sum = Object.values(result).reduce(
              (acc: number, val) => acc + (typeof val === "number" ? val : 0),
              0
            );
            setOverAllVulnerbailityTotal(sum);
          } else {
            setOverAllVulnerbailityTotal(total_count);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching compliance data:", error);
    }
  };

  const fetchCveVulnerability = async () => {
    if (!assetData) return;

    try {
      // NOTE: Previously fetched via GET from 'securityscan/dashboard-cve-vulnerabilities'.
      // Backend removed 'dashboard-cve-vulnerabilities' API and consolidated the logic into 'dashboard-overall-vulnerabilities' (END_POINTS.DASHBOARD_MISCONFIGURATION).
      // It is now called using POST with payload { module: "dashboard-cve-vulnerabilities", device_uuid: assetData.id, scope: isCloud ? "cloud" : "on_premise" }.
      const payload = {
        module: "dashboard-cve-vulnerabilities",
        device_uuid: assetData.id,
        scope: isCloud ? "cloud" : "on_premise",
      };
      const response = await axiosInstance.post(
        END_POINTS.DASHBOARD_MISCONFIGURATION,
        payload,
        {
          params: {
            device_uuid: assetData.id,
          },
        }
      );
      if (response.data.status === 200) {
        setCveVulnerability(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching compliance data:", error);
    }
  };

  const fetchCyberResilienceData = async (date: any) => {
    if (!assetData) return;
    setIsChartLoading(true);
    const endDate = moment().format("YYYY-MM-DD");
    const startDate = moment()
      .subtract(parseInt(date), "days")
      .format("YYYY-MM-DD");
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const payload: any = {
      duration: "custom_date_range",
      device_id: assetData.id,
      start_date: startDate,
      end_date: endDate,
      timezone: timeZone,
    };
    if (isCloud) {
      payload.module = "cloud";
      payload.cve = false;
      payload.intelli_score = false;
      payload.rating = true;
    } else {
      payload.module = "on_premise";
      payload.cve = true;
      payload.intelli_score = true;
      payload.rating = true;
    }
    try {
      const response = await axiosInstance.post(
        END_POINTS.DASHBOARD_CYBER_RESILIENCE_TREND,
        payload
      );
      if (response.data.status === 200) {
        const graphData = response?.data?.data?.graph_data || [];
        setCyberGraphData(graphData);
      }
    } catch (error) {
      console.error("Error fetching compliance data:", error);
      setCyberGraphData([]);
    } finally {
      setIsChartLoading(false);
    }
  };

  const loadAllData = async () => {
    if (!assetData) return;

    try {
      setIsLoading(true);
      await Promise.all([
        fetchCVEData(),
        fetchCyberResilienceData("7"),
        fetchMisconfigData(),
        fetchSecurityScore(),
        fetchComplianceData(),
        fetchOverAllVulnerabilities(),
        fetchCveVulnerability(),
      ]);
    } catch (error) {
      console.error("Error loading data:", error);
    } finally {
      setIsLoading(false);
      // Initialize timeline chart after data is loaded
      setTimeout(() => {
        initializeTimelineChart();
      }, 100);
    }
  };

  // Extract the timeline chart initialization to a separate function
  // const initializeTimelineChart = () => {
  //   if (!timelineChartRef.current || !cyberGraphData) return;

  //   // Dispose existing chart instance if any
  //   const existingChart = echarts.getInstanceByDom(timelineChartRef.current);
  //   if (existingChart) {
  //     existingChart.dispose();
  //   }

  //   // Initialize new chart
  //   const timelineChart = echarts.init(timelineChartRef.current);

  //   const dates = cyberGraphData.map((data: any) => data.date_time || "");
  //   console.log(dates);
  //   const intelliScores = cyberGraphData.map(
  //     (data: any) => data.intelli_score || 0
  //   );
  //   const postureScores = cyberGraphData.map(
  //     (data: any) => data.security_rating || 0
  //   );
  //   const cveScores = cyberGraphData.map((data: any) => data.cve_score || 0);

  //   const timelineOption = {
  //     tooltip: {
  //       trigger: "axis",
  //       axisPointer: {
  //         type: "cross",
  //       },
  //     },
  //     legend: {
  //        data: [
  //   { name: "Intelliscore", icon: "circle", itemStyle: { color: colors.intelliscore } },
  //   { name: "Posture Score", icon: "circle", itemStyle: { color: colors.posture } },
  //   { name: "CVE Score", icon: "circle", itemStyle: { color: colors.cve } },
  // ],
  //       selected: {
  //         Intelliscore: true,
  //         "Posture Score": true,
  //         "CVE Score": true,
  //       },
  //       top: 0,
  //       icon: "circle",
  //       itemWidth: 8,
  //       itemHeight: 8,
  //       textStyle: {
  //         fontSize: '12px',
  //         color: theme.palette.text.primary,
  //       },
  //     },
  //     grid: {
  //       top: 40,
  //       right: 20,
  //       bottom: 30,
  //       left: 40,
  //       containLabel: true,
  //     },
  //     xAxis: {
  //       type: "category",
  //       boundaryGap: false,
  //       data: dates,
  //       axisLine: {
  //         lineStyle: {
  //           color: theme.palette.mode === "dark" ? "#424242" : "#E5E7EB",
  //         },
  //       },
  //       axisLabel: {
  //         formatter: (value: string) => moment(value).format("MMM DD"),
  //         interval: Math.max(1, Math.floor(dates.length / 7)),
  //         color: theme.palette.text.secondary,
  //       },
  //     },
  //     yAxis: {
  //       type: "value",
  //       splitLine: {
  //         show: false,
  //       },
  //       axisLabel: {
  //         color: theme.palette.text.secondary,
  //       },
  //     },
  //     series: [
  //       {
  //         name: "Intelliscore",
  //         type: "line",
  //         smooth: true,
  //         symbol: "none",
  //         lineStyle: { color: "#5590FF", width: 2 },
  //         areaStyle: {
  //           color: {
  //             type: "linear",
  //             x: 0,
  //             y: 0,
  //             x2: 0,
  //             y2: 1,
  //             colorStops: [
  //               { offset: 0, color: "rgba(79, 70, 229, 0.2)" },
  //               { offset: 1, color: "rgba(79, 70, 229, 0)" },
  //             ],
  //           },
  //         },
  //         data: intelliScores,
  //       },
  //       {
  //         name: "Posture Score",
  //         type: "line",
  //         smooth: true,
  //         symbol: "none",
  //         lineStyle: { color: "#F03C3C", width: 2 },
  //         areaStyle: {
  //           color: {
  //             type: "linear",
  //             x: 0,
  //             y: 0,
  //             x2: 0,
  //             y2: 1,
  //             colorStops: [
  //               { offset: 0, color: "rgba(244, 67, 54, 0.2)" },
  //               { offset: 1, color: "rgba(244, 67, 54, 0)" },
  //             ],
  //           },
  //         },
  //         data: postureScores,
  //       },
  //       {
  //         name: "CVE Score",
  //         type: "line",
  //         smooth: true,
  //         symbol: "none",
  //         lineStyle: { color: "#00A61B", width: 2 },
  //         areaStyle: {
  //           color: {
  //             type: "linear",
  //             x: 0,
  //             y: 0,
  //             x2: 0,
  //             y2: 1,
  //             colorStops: [
  //               { offset: 0, color: "rgba(76, 175, 80, 0.2)" },
  //               { offset: 1, color: "rgba(76, 175, 80, 0)" },
  //             ],
  //           },
  //         },
  //         data: cveScores,
  //       },
  //     ],
  //   };

  //   timelineChart.setOption(timelineOption);
  //   timelineChart.resize();
  // };

  const initializeTimelineChart = () => {
    if (!timelineChartRef.current) return;

    // Check if the container has dimensions
    const container = timelineChartRef.current;
    if (container.offsetWidth === 0 || container.offsetHeight === 0) {
      // Container not ready, try again later
      setTimeout(() => {
        initializeTimelineChart();
      }, 100);
      return;
    }

    // Don't initialize chart if still loading
    if (isChartLoading) {
      return;
    }

    // Dispose existing chart instance if any
    const existingChart = echarts.getInstanceByDom(timelineChartRef.current);
    if (existingChart) {
      existingChart.dispose();
    }

    // Additional cleanup to ensure no charts remain
    if (container) {
      // Force cleanup by checking if there are any charts attached
      const chartInstance = echarts.getInstanceByDom(container);
      if (chartInstance) {
        chartInstance.dispose();
      }
    }

    // Initialize new chart
    const timelineChart = echarts.init(timelineChartRef.current);
    if (cyberGraphData.length === 0) {
      const timeRangeText =
        timeRange === "7"
          ? "7 days"
          : timeRange === "30"
            ? "30 days"
            : "90 days";
      const noDataOption = {
        graphic: [
          {
            type: "text",
            left: "center",
            top: "middle",
            style: {
              // text: `No Data Available for Last ${timeRangeText}`,
              fontSize: 16,
              fill: theme.palette.text.secondary,
              fontWeight: "normal",
            },
          },
          {
            type: "text",
            left: "center",
            top: "middle",
            style: {
              text: `No Data Available for Last ${timeRangeText}`,
              fontSize: 12,
              fill: theme.palette.text.disabled,
              fontWeight: "normal",
              y: 30,
            },
          },
        ],
      };
      timelineChart.setOption(noDataOption);
    }
    // Check if we have data
    if (!cyberGraphData || cyberGraphData.length === 0) {
      // Show "No Data" message with time range context
      const timeRangeText =
        timeRange === "7"
          ? "7 days"
          : timeRange === "30"
            ? "30 days"
            : "90 days";
      const noDataOption = {
        graphic: [
          {
            type: "text",
            left: "center",
            top: "middle",
            style: {
              // text: `No Data Available for Last ${timeRangeText}`,
              fontSize: 16,
              fill: theme.palette.text.secondary,
              fontWeight: "normal",
            },
          },
          {
            type: "text",
            left: "center",
            top: "middle",
            style: {
              text: `No Data Available for Last ${timeRangeText}`,
              fontSize: 12,
              fill: theme.palette.text.disabled,
              fontWeight: "normal",
              y: 30,
            },
          },
        ],
      };
      timelineChart.setOption(noDataOption);
      return;
    }

    // Filter out invalid data points
    const validData = cyberGraphData.filter(
      (data: any) =>
        (data.date_time) &&
        ((data.intelli_score !== undefined &&
          data.intelli_score !== null) ||
          (data.security_rating !== undefined && data.security_rating !== null) ||
          (data.cve_score !== undefined && data.cve_score !== null))
    );

    if (validData.length === 0) {
      // Show "No Data" message with time range context
      const timeRangeText =
        timeRange === "7"
          ? "7 days"
          : timeRange === "30"
            ? "30 days"
            : "90 days";
      const noDataOption = {
        graphic: [
          {
            type: "text",
            left: "center",
            top: "middle",
            style: {
              text: `No Valid Data Available for Last ${timeRangeText}`,
              fontSize: 16,
              fill: theme.palette.text.secondary,
              fontWeight: "normal",
            },
          },
          {
            type: "text",
            left: "center",
            top: "middle",
            style: {
              text: `No Data Available for Last ${timeRangeText}`,
              fontSize: 12,
              fill: theme.palette.text.disabled,
              fontWeight: "normal",
              y: 30,
            },
          },
        ],
      };
      timelineChart.setOption(noDataOption);
      return;
    }

    const dates = validData.map((data: any) => data.date_time || "");
    const intelliScores = validData.map((data: any) => data.intelli_score || 0);
    const postureScores = validData.map(
      (data: any) => data.security_rating || 0
    );
    const cveScores = validData.map((data: any) => data.cve_score || 0);
    console.log(isCloud, "isCloud");
    console.log(dates, "dates");
    console.log(intelliScores, "intelliScores");
    const timelineOption = {
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
        },
        formatter: (params: any) => {
          let tooltipText = `${moment(params[0].axisValue).format(
            "YYYY-MM-DD"
          )}<br/>`;
          params.forEach((item: any) => {
            let color = "#000";
            if (item.seriesName === "Intelliscore") color = "#5590FF";
            if (item.seriesName === "Posture Score") color = "#F03C3C";
            if (item.seriesName === "CVE Score") color = "#00A61B";

            tooltipText += `
            <span style="display:inline-block;margin-right:5px;border-radius:50%;width:8px;height:8px;background-color:${color};"></span>
            <span>${item.seriesName}: <b style="color:${color}">${item.data}</b></span><br/>
          `;
          });
          return tooltipText;
        },
      },
      legend: {
        data: isCloud
          ? [
            {
              name: "Posture Score",
              icon: "circle",
              itemStyle: { color: "#F03C3C" },
            },
          ]
          : [
            {
              name: "Intelliscore",
              icon: "circle",
              itemStyle: { color: "#5590FF" },
            },
            {
              name: "Posture Score",
              icon: "circle",
              itemStyle: { color: "#F03C3C" },
            },
            {
              name: "CVE Score",
              icon: "circle",
              itemStyle: { color: "#00A61B" },
            },
          ],
        selected: {
          Intelliscore: true,
          "Posture Score": true,
          "CVE Score": true,
        },
        top: 0,
        icon: "circle",
        itemWidth: 8,
        itemHeight: 8,
        textStyle: {
          fontSize: "12px",
          color: theme.palette.text.primary,
        },
      },
      grid: {
        top: 40,
        right: 20,
        bottom: 30,
        left: 40,
        containLabel: true,
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: dates,
        axisLine: {
          lineStyle: {
            color: theme.palette.mode === "dark" ? "#424242" : "#E5E7EB",
          },
        },
        axisLabel: {
          formatter: (value: string) => moment(value).format("MMM DD"),
          interval: Math.max(1, Math.floor(dates.length / 7)),
          color: theme.palette.text.secondary,
        },
      },
      yAxis: {
        type: "value",
        splitLine: {
          show: false,
        },
        axisLabel: {
          color: theme.palette.text.secondary,
        },
      },
      series: isCloud ? [
        {
          name: "Posture Score",
          type: "line",
          smooth: true,
          symbol: "none",
          lineStyle: { color: "#F03C3C", width: 2 },
          areaStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                { offset: 0, color: "rgba(240, 60, 60, 0.2)" },
                { offset: 1, color: "rgba(240, 60, 60, 0)" },
              ],
            },
          },
          data: postureScores,
        }

      ] : [
        {
          name: "Intelliscore",
          type: "line",
          smooth: true,
          symbol: "none",
          lineStyle: { color: "#5590FF", width: 2 },
          areaStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                { offset: 0, color: "rgba(85, 144, 255, 0.2)" },
                { offset: 1, color: "rgba(85, 144, 255, 0)" },
              ],
            },
          },
          data: intelliScores,
        },
        {
          name: "Posture Score",
          type: "line",
          smooth: true,
          symbol: "none",
          lineStyle: { color: "#F03C3C", width: 2 },
          areaStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                { offset: 0, color: "rgba(240, 60, 60, 0.2)" },
                { offset: 1, color: "rgba(240, 60, 60, 0)" },
              ],
            },
          },
          data: postureScores,
        },
        {
          name: "CVE Score",
          type: "line",
          smooth: true,
          symbol: "none",
          lineStyle: { color: "#00A61B", width: 2 },
          areaStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                { offset: 0, color: "rgba(0, 166, 27, 0.2)" },
                { offset: 1, color: "rgba(0, 166, 27, 0)" },
              ],
            },
          },
          data: cveScores,
        },
      ],
    };

    timelineChart.setOption(timelineOption);
    timelineChart.resize();

    // Add a small delay to ensure proper rendering
    setTimeout(() => {
      timelineChart.resize();
    }, 50);
  };

  useEffect(() => {
    if (open) {
      setTabValue(getDefaultTabValue());
      setTimeRange("7");
      // Clear previous chart data and set loading state
      setCyberGraphData(null);
      setIsChartLoading(true);
      loadAllData();
    } else {
      // Cleanup chart when drawer closes
      if (timelineChartRef.current) {
        const chart = echarts.getInstanceByDom(timelineChartRef.current);
        chart?.dispose();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, getDefaultTabValue, (assetData as any)?.id, (assetData as any)?.asset_id, (assetData as any)?.device_id]);

  // Handle time range change and reinitialize chart
  useEffect(() => {
    if (
      open &&
      !isChartLoading &&
      timelineChartRef.current &&
      cyberGraphData !== null
    ) {
      // Clear any existing timeouts to prevent multiple calls
      const timeoutId = setTimeout(() => {
        initializeTimelineChart();
      }, 100);

      return () => clearTimeout(timeoutId);
    }
  }, [timeRange, open, isChartLoading, cyberGraphData]);

  // Handle window resize and cleanup
  useEffect(() => {
    const handleResize = () => {
      if (!timelineChartRef.current) return;
      const chart = echarts.getInstanceByDom(timelineChartRef.current);
      chart?.resize();
    };

    window.addEventListener("resize", handleResize);
    
    const chartRef = timelineChartRef.current;

    return () => {
      window.removeEventListener("resize", handleResize);
      // Cleanup chart when component unmounts
      if (chartRef) {
        const chart = echarts.getInstanceByDom(chartRef);
        chart?.dispose();
      }
    };
  }, []);

  // Single effect to handle chart initialization after data loads
  useEffect(() => {
    if (open && !isChartLoading && cyberGraphData !== null) {
      const timeoutId = setTimeout(() => {
        initializeTimelineChart();
      }, 200);

      return () => clearTimeout(timeoutId);
    }
  }, [open, isChartLoading, cyberGraphData]);

  // Cleanup effect when component unmounts or drawer closes
  useEffect(() => {
    const chartRef = timelineChartRef.current;
    return () => {
      if (chartRef) {
        const chart = echarts.getInstanceByDom(chartRef);
        if (chart) {
          chart.dispose();
        }
      }
    };
  }, []);

  useEffect(() => {
    if (tabValue === 0 && open) {
      // Only reset time range and fetch data if this is the first time opening the tab
      // or if we don't have any data yet
      // if (!cyberGraphData || timeRange !== "7") {
      //   setTimeRange("7");
      //   fetchCyberResilienceData("7");
      // }
      fetchCyberResilienceData(timeRange);
    }
  }, [tabValue, open]);

  // Handle time range change
  const handleTimeRangeChange = async (event: SelectChangeEvent<string>) => {
    const newTimeRange = event.target.value;
    setTimeRange(newTimeRange);

    // Clear previous data first to show loading state
    setCyberGraphData(null);

    // Clean up any existing chart to prevent overlapping
    if (timelineChartRef.current) {
      const existingChart = echarts.getInstanceByDom(timelineChartRef.current);
      if (existingChart) {
        existingChart.dispose();
      }
    }

    // Fetch new data for the selected time range
    await fetchCyberResilienceData(newTimeRange);

    // Chart will be reinitialized automatically via useEffect when data loads
  };

  const columnDefs: ColDef[] = [
    {
      field: "id",
      headerName: "#",
      minWidth: 70,
      valueGetter: (params: any) => params.node.rowIndex + 1,
      filter: false,
    },
    // {
    //   field: "cve_id",
    //   headerName: "CVE",
    //   flex: 1,
    //   cellRenderer: (params: ICellRendererParams) => (
    //     <Typography variant="body2">
    //       {params.value}
    //     </Typography>
    //   ),
    //   cellStyle: {
    //     display: "flex",
    //     alignItems: "center",
    //   },
    // },
    {
      field: "cve_id",
      headerName: "CVE",
      filter: true,
      minWidth: 200,
      width: 200,
      flex: 1,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
      cellRenderer: (params: any) => {
        const value = params.value || "";
        const parameterType = params.data?.parameter_type || "";
        const isManual = parameterType === "Manual";
        // const color = isManual ? "#F7941F" : "#696595";
        const color = isManual
          ? isDarkMode
            ? "#FFB74D"
            : "#F7941F"
          : isDarkMode
            ? "#B2B2FF"
            : "#696595";
        const bgcolor = isManual ? "#F7941F" : "#696595";

        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              gap: 8,
            }}
          >
            <WhiteTooltip title={value}>
              <Typography
                variant="body2"
                sx={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  fontWeight: "bold",
                  flex: 1,
                }}
              >
                {value}
              </Typography>
            </WhiteTooltip>

          </div>
        );
      },
    },
    {
      field: "score",
      headerName: "CVSS",
      flex: 1,
      minWidth: 100,
      cellRenderer: (params: ICellRendererParams) => (
        <Typography variant="body2">{params.value}</Typography>
      ),
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "severity",
      headerName: "Severity",
      flex: 1,
      minWidth: 120,
      // sort: "desc",
      cellRenderer: (params: any) => {
        const severityStyles: any = {
          Critical: { bgcolor: isDarkMode ? "rgba(255, 61, 61, 0.18)" : "#67000424", color: isDarkMode ? "#FF3D3D" : "#670004" },
          High: { bgcolor: isDarkMode ? "rgba(255, 107, 107, 0.15)" : "#A7000F24", color: isDarkMode ? "#FF6B6B" : "#A7000F" },
          Medium: { bgcolor: isDarkMode ? "rgba(255, 167, 38, 0.15)" : "#E8580024", color: isDarkMode ? "#FFA726" : "#E85800" },
          Low: { bgcolor: isDarkMode ? "rgba(255, 224, 130, 0.15)" : "#F2BF0024", color: isDarkMode ? "#FFE082" : "#F2BF00" },
        };
        return (
          <Chip
            label={params.value}
            size="small"
            sx={{
              bgcolor: severityStyles[params.value]?.bgcolor || "#f5f5f5",
              color: severityStyles[params.value]?.color || "#666666",
              height: "20px",
              borderRadius: "4px",
              position: "relative",
              fontWeight: 600,
              p: 1.5,
              pr: 0,
              "&::before": {
                content: '""',
                position: "absolute",
                left: 8,
                top: "50%",
                transform: "translateY(-50%)",
                width: 8,
                height: 8,
                bgcolor: severityStyles[params.value]?.color || "#666666",
                borderRadius: "50%",
              },
              "& .MuiChip-label": { px: 1 },
            }}
          />
        );
      },
    },
    {
      field: "cisas_kev",
      headerName: "CISA's KEV",
      minWidth: 150,
      flex: 1,

      headerComponent: () => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <span>CISA's KEV</span>
          <WhiteTooltip title="Exploit Prediction Scoring System">
            <InfoIcon fontSize="small" />
          </WhiteTooltip>

        </Box>
      ),
      cellRenderer: (params: ICellRendererParams) => (
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            color: params.value
              ? "#F53B3B"
              : isDarkMode
                ? "#FFFFFF"
                : "#000000",
          }}
          onClick={() => handleCVEClick(params.data)}
        >
          {params.value ? "Exploited " : "Not Exploited"}
        </Typography>
      ),
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "epss",
      headerName: "EPSS",
      flex: 1,
      minWidth: 120,
      headerComponent: () => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <span>EPSS</span>
          <WhiteTooltip title="Known Exploited Vulnerabilities">
            <InfoIcon fontSize="small" />
          </WhiteTooltip>

        </Box>
      ),
      cellRenderer: (params: ICellRendererParams) => (
        <Typography variant="body2">
          {(parseFloat(params.value) * 100).toFixed(2)}%
        </Typography>
      ),
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
  ];
  const severityStyles: any = {
    Critical: { bgcolor: isDarkMode ? "rgba(255, 61, 61, 0.18)" : "#67000424", color: isDarkMode ? "#FF3D3D" : "#670004" },
    High: { bgcolor: isDarkMode ? "rgba(255, 107, 107, 0.15)" : "#A7000F24", color: isDarkMode ? "#FF6B6B" : "#A7000F" },
    Medium: { bgcolor: isDarkMode ? "rgba(255, 167, 38, 0.15)" : "#E8580024", color: isDarkMode ? "#FFA726" : "#E85800" },
    Low: { bgcolor: isDarkMode ? "rgba(255, 224, 130, 0.15)" : "#F2BF0024", color: isDarkMode ? "#FFE082" : "#F2BF00" },
  };
  const agGridInlineStyles = useMemo(
    () => ({
      padding: "0px",
      // "& .ag-body-vertical-scroll": {
      //   width: "0px !important",
      //   minWidth: "0px !important",
      // },
      // "& .ag-body-vertical-scroll-viewport": {
      //   width: "0px !important",
      //   minWidth: "0px !important",
      // },
      "& .ag-center-cols-clipper": {
        marginRight: 0,
      },
      "& .ag-center-cols-viewport": {
        marginRight: 0,
      },
    }),
    []
  );

  const memoizedGridOptions = useMemo(
    () => ({
      getRowStyle: () => ({ cursor: "pointer" }),
    }),
    []
  );

  const portsColumnDefs: ColDef[] = [
    {
      field: "port",
      headerName: "Name",
      filter: true,
      minWidth: 80,
      flex: 0.8,
      valueFormatter: (params: any) =>
        params.value !== null && params.value !== undefined && String(params.value).trim() !== ""
          ? params.value
          : "-",
      cellStyle: {
        display: "flex",
        alignItems: "center",
        fontWeight: 500,
      },
    },
    {
      field: "protocol",
      headerName: "Protocol",
      filter: true,
      minWidth: 90,
      flex: 0.8,
      valueFormatter: (params: any) =>
        params.value !== null && params.value !== undefined && String(params.value).trim() !== ""
          ? params.value
          : "-",
      cellStyle: {
        display: "flex",
        alignItems: "center",
        textTransform: "uppercase",
      },
    },
    {
      field: "state",
      headerName: "State",
      filter: true,
      minWidth: 100,
      flex: 0.8,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
      cellRenderer: (params: ICellRendererParams) => {
        if (params.value === null || params.value === undefined || String(params.value).trim() === "") {
          return "-";
        }
        const state = String(params.value);
        const isOpen = state.toLowerCase() === "open";
        const isClosed = state.toLowerCase() === "closed";
        return (
          <Chip
            label={state}
            size="small"
            sx={{
              fontWeight: 600,
              fontSize: "11px",
              textTransform: "capitalize",
              height: "24px",
              borderRadius: "4px",
              bgcolor: isOpen
                ? isDarkMode
                  ? "rgba(34, 197, 94, 0.15)"
                  : "#ECFDF5"
                : isClosed
                ? isDarkMode
                  ? "rgba(239, 68, 68, 0.15)"
                  : "#FEF2F2"
                : isDarkMode
                ? "rgba(156, 163, 175, 0.15)"
                : "#F3F4F6",
              color: isOpen
                ? isDarkMode
                  ? "#4ADE80"
                  : "#16A34A"
                : isClosed
                ? isDarkMode
                  ? "#F87171"
                  : "#DC2626"
                : isDarkMode
                ? "#9CA3AF"
                : "#6B7280",
              border: `1px solid ${
                isOpen
                  ? isDarkMode
                    ? "rgba(34, 197, 94, 0.3)"
                    : "#BBF7D0"
                  : isClosed
                  ? isDarkMode
                    ? "rgba(239, 68, 68, 0.3)"
                    : "#FECACA"
                  : isDarkMode
                  ? "rgba(156, 163, 175, 0.3)"
                  : "#E5E7EB"
              }`,
            }}
          />
        );
      },
    },
    {
      field: "service_name",
      headerName: "Service",
      filter: true,
      minWidth: 80,
      flex: 0.8,
      valueFormatter: (params: any) =>
        params.value !== null && params.value !== undefined && String(params.value).trim() !== ""
          ? params.value
          : "-",
      cellStyle: {
        display: "flex",
        alignItems: "center",
        textTransform: "uppercase",
      },
    },
    {
      field: "service_product",
      headerName: "Details",
      filter: true,
      minWidth: 150,
      flex: 1.5,
      valueFormatter: (params: any) =>
        params.value !== null && params.value !== undefined && String(params.value).trim() !== ""
          ? params.value
          : "-",
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
  ];

  const misconfigColumnDefs: ColDef[] = [
    // {
    //   field: "param_name",
    //   headerName: "Parameter",
    //   minWidth: 200,
    //   width: 250,
    //   flex: 1,
    //   cellRenderer: (params: ICellRendererParams) => (
    //     <Tooltip title={params.value || ""} arrow>
    //       <Typography
    //         variant="body2"
    //         sx={{
    //           display: "flex",
    //           overflow: "hidden",
    //           textOverflow: "ellipsis",
    //           alignItems: "center",
    //           height: "100%",
    //         }}
    //       >
    //         {params.value}
    //       </Typography>
    //     </Tooltip>
    //   ),
    // },
    {
      field: "param_name",
      headerName: "Recommendation",
      filter: true,
      minWidth: 350,
      width: 350,
      flex: 1,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
      cellRenderer: (params: any) => {
        const value = params.value || "";
        const parameterType = params.data?.parameter_type || "";
        const isManual = parameterType === "Manual";
        // const color = isManual ? "#F7941F" : "#696595";
        const color = isManual
          ? isDarkMode
            ? "#FFB74D"
            : "#F7941F"
          : isDarkMode
            ? "#B2B2FF"
            : "#696595";
        const bgcolor = isManual ? "#F7941F" : "#696595";

        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              gap: 8,
            }}
          >

            <WhiteTooltip title={value}>
              <Typography
                variant="body2"
                sx={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  fontWeight: "bold",
                  flex: 1,
                }}
              >
                {value}
              </Typography>
            </WhiteTooltip>


          </div>
        );
      },
    },
    {
      field: "severity",
      headerName: "Severity",
      flex: 1,
      minWidth: 120,
      // sort: "desc",
      comparator: (valueA, valueB) => {
        return getSeverityValue(valueB) - getSeverityValue(valueA);
      },
      cellRenderer: (params: any) => {
        return (
          <Chip
            label={params.value}
            size="small"
            sx={{
              bgcolor: severityStyles[params.value]?.bgcolor || "#f5f5f5",
              color: severityStyles[params.value]?.color || "#666666",
              height: "20px",
              borderRadius: "4px",
              position: "relative",
              fontWeight: 600,
              p: 1.5,
              pr: 0,
              "&::before": {
                content: '""',
                position: "absolute",
                left: 8,
                top: "50%",
                transform: "translateY(-50%)",
                width: 8,
                height: 8,
                bgcolor: severityStyles[params.value]?.color || "#666666",
                borderRadius: "50%",
              },
              "& .MuiChip-label": { px: 1 },
            }}
          />
        );
      },
    },
    {
      field: "accepted_count",
      headerName: "Risk Accepted",
      filter: true,

      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
      minWidth: 150,
      cellRenderer: (params: any) =>
        params.value > 0 ? (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, pt: 1 }}>
            <img src={Exclamation} alt="exclamation" height="20" />
            <Typography>{params.value}</Typography>
          </Box>
        ) : (
          <img
            src={AcceptedRisk_False}
            alt="warning"
            style={{ height: "20px" }}
          />
        ),
    },
    {
      field: "compliance",
      headerName: "Compliance",
      flex: 1,
      minWidth: 130,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
      cellRenderer: (params: ICellRendererParams) => {
        return (
          <img
            src={params.value ? verifiedImg : notVerifiedImg}
            alt={params.value ? "Verified" : "Not Verified"}
            style={{ width: "20px", height: "20px" }}
          />
        );
      },
    },
  ];

  const getCriticalityColor = (severity: any) => {
    switch (severity?.toLowerCase()) {
      case "critical":
        return "#B71E31";
      case "high":
        return "#FF6600";
      case "medium":
        return "#E0B102";
      case "low":
        return "#00A61B";
      default:
        return "#B71E31";
    }
  };

  const getPostureScoreOption = () => ({
    series: [
      {
        type: "gauge",
        startAngle: 180,
        endAngle: 0,
        min: 0,
        max: 100,
        radius: "100%",
        itemStyle: {
          color: "#4F46E5",
        },
        progress: {
          show: true,
          roundCap: true,
          width: 8,
        },
        pointer: {
          show: false,
        },
        axisLine: {
          roundCap: true,
          lineStyle: {
            width: 8,
            color: [[1, theme.palette.mode === "dark" ? "#424242" : "#E3F2FD"]],
          },
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
        title: {
          show: false,
        },
        detail: {
          show: true,
          offsetCenter: [0, 0],
          fontSize: 20,
          fontWeight: 600,
          formatter: "{value}",
          color: theme.palette.text.primary,
        },
        data: [
          {
            value: 15,
          },
        ],
      },
    ],
  });

  const getCVEScoreOption = () => ({
    series: [
      {
        type: "gauge",
        startAngle: 180,
        endAngle: 0,
        min: 0,
        max: 100,
        radius: "100%",
        itemStyle: {
          color: "#FF9800",
        },
        progress: {
          show: true,
          roundCap: true,
          width: 8,
        },
        pointer: {
          show: false,
        },
        axisLine: {
          roundCap: true,
          lineStyle: {
            width: 8,
            color: [[1, theme.palette.mode === "dark" ? "#424242" : "#FFF3E0"]],
          },
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
        title: {
          show: false,
        },
        detail: {
          show: true,
          offsetCenter: [0, 0],
          fontSize: 20,
          fontWeight: 600,
          formatter: "{value}",
          color: theme.palette.text.primary,
        },
        data: [
          {
            value: 58,
          },
        ],
      },
    ],
  });

  useEffect(() => {
    // Initialize charts
    let postureChart: echarts.ECharts | undefined;
    let cveChart: echarts.ECharts | undefined;

    if (postureChartRef.current) {
      postureChart = echarts.init(postureChartRef.current);
      postureChart.setOption(getPostureScoreOption());
    }

    if (cveChartRef.current) {
      cveChart = echarts.init(cveChartRef.current);
      cveChart.setOption(getCVEScoreOption());
    }

    // Handle resize
    const handleResize = () => {
      postureChart?.resize();
      cveChart?.resize();
    };
    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => {
      window.removeEventListener("resize", handleResize);
      postureChart?.dispose();
      cveChart?.dispose();
    };
  }, [open]); // Re-initialize when drawer opens/closes

  useEffect(() => {
    const handleCloseAll = () => {
      setCveDrawerOpen(false);
      setMisconfigDrawerOpen(false);
      setReportDrawerOpen(false);
      setDownloadModalOpen(false);
      onClose();
    };
    eventEmitter.on("closeAllDrawers", handleCloseAll);
    return () => {
      eventEmitter.off("closeAllDrawers", handleCloseAll);
    };
  }, [onClose]);

  const handleChatSubmit = async () => {
    if (!chatInput.trim() || !assetData?.id) return;

    setIsLoadingChat(true);
    try {
      const response = await axiosInstance.get(`securityscan/config-analyzer`, {
        params: {
          query: chatInput.trim(),
          device_uuid: assetData.id,
        },
      });

      if (response.data) {
        setChatResponse(response.data);
      }
    } catch (error) {
      console.error("Error fetching chat response:", error);
      setChatResponse({
        status: 500,
        message: "Error",
        data: {
          result: "Sorry, there was an error processing your request.",
        },
      });
    } finally {
      setIsLoadingChat(false);
    }
  };

  const formatChatResponse = (response: string) => {
    // Split the response into parts based on code blocks
    const parts = response.split(/```(.*?)\n([\s\S]*?)```/);

    return parts.map((part, index) => {
      if (index % 3 === 0) {
        // Regular text - handle bold text with **
        return part.split(/\*\*(.*?)\*\*/).map((text, i) =>
          i % 2 === 0 ? (
            <span key={i}>{text}</span>
          ) : (
            <Typography
              component="span"
              key={i}
              sx={{
                fontWeight: "bold",
                color: theme.palette.primary.main,
              }}
            >
              {text}
            </Typography>
          )
        );
      } else if (index % 3 === 1) {
        // Code language
        return null;
      } else {
        // Code block
        return (
          <Box
            key={index}
            sx={{
              my: 2,
              p: 2,
              borderRadius: 1,
              bgcolor:
                theme.palette.mode === "dark"
                  ? "rgba(255, 255, 255, 0.05)"
                  : "rgba(0, 0, 0, 0.03)",
              border: `1px solid ${theme.palette.mode === "dark"
                ? "rgba(255, 255, 255, 0.1)"
                : "rgba(0, 0, 0, 0.1)"
                }`,
              fontFamily: "monospace",
              fontSize: "0.875rem",
              position: "relative",
              "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                width: "3px",
                height: "100%",
                bgcolor: theme.palette.primary.main,
                borderTopLeftRadius: 1,
                borderBottomLeftRadius: 1,
              },
            }}
          >
            <pre
              style={{
                margin: 0,
                whiteSpace: "pre-wrap",
                wordWrap: "break-word",
              }}
            >
              {part}
            </pre>
          </Box>
        );
      }
    });
  };

  const handleDownloadReport = () => {

    setDownloadLoading(true);
    const payload = {
      report_format: reportFormat.toLowerCase(),

      time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      type: "asset_report",
      asset_ids: [assetData?.id || ""],
      //organization_id: organization_id,
      module: isCloud ? "cloud" : "on_premise",
    };
    console.log(payload, 'payload');

    axiosInstance.post(END_POINTS.REPORT_DOWNLOAD, payload)
      .then(response => {
        if (response.status === 200) {
          toast.success("Report request submitted, please check Reports section.");
        }
        setDownloadModalOpen(false);
        //saveFile(response.data, 'AssetsComplianceReport');
        //onClose();
      })
      .catch(error => {
        console.error('Error making API call:', error);
        toast.error("Failed to submit report request, please try again.");
      })
      .finally(() => {
        //setDownloadLoading(false);
        setDownloadModalOpen(false);
        setDownloadLoading(false);
      });

  };

  const seriesData = [
    overAllvulnerbaility?.critical || 0,
    overAllvulnerbaility?.high || 0,
    overAllvulnerbaility?.medium || 0,
    overAllvulnerbaility?.low || 0,
  ];

  const isAllZero = overAllVulnerbailityTotal === 0;

  const chartMisOptions = {
    chart: {
      type: "donut" as const,
      height: 120,
      sparkline: { enabled: true },
      toolbar: { show: false },
    },
    plotOptions: {
      pie: {
        startAngle: -90,
        endAngle: 90,
        donut: {
          size: "70%",
        },
        expandOnClick: false,
        customScale: 1,
      },
    },
    colors: isAllZero
      ? ["#D3D3D3"]
      : ["#670004", "#A7000F", "#E85800", "#F2BF00"],
    labels: ["Critical", "High", "Medium", "Low"],
    legend: { show: false },
    dataLabels: { enabled: false },
    stroke: { width: 0 },
    states: {
      hover: {
        filter: { type: "none" },
      },
      active: {
        filter: { type: "none" },
      },
    },
    tooltip: {
      enabled: !isAllZero,
    },
  };

  const chartMisSeries = isAllZero ? [1] : seriesData;

  const cveSeries = [
    cveVulnerability?.critical || 0,
    cveVulnerability?.high || 0,
    cveVulnerability?.medium || 0,
    cveVulnerability?.low || 0,
  ];

  const isCveAllZero = cveSeries.every((val) => val === 0);

  const cveOptions = {
    chart: {
      type: "donut" as const,
      height: 120,
      sparkline: { enabled: true },
      toolbar: { show: false },
    },
    plotOptions: {
      pie: {
        startAngle: -90,
        endAngle: 90,
        donut: {
          size: "70%",
        },
        expandOnClick: false,
        customScale: 1,
      },
    },
    colors: isCveAllZero
      ? ["#D3D3D3"]
      : ["#670004", "#A7000F", "#E85800", "#F2BF00"],
    labels: ["Critical", "High", "Medium", "Low"],
    legend: { show: false },
    dataLabels: { enabled: false },
    stroke: { width: 0 },
    states: {
      hover: {
        filter: { type: "none" },
      },
      active: {
        filter: { type: "none" },
      },
    },
    tooltip: {
      enabled: !isCveAllZero,
    },
  };

  const cveSeriesFinal = isCveAllZero ? [1] : cveSeries;

  if (!assetData) return null;

  return (
    <>
      <Drawer
        anchor="right"
        open={open}
        ModalProps={{ disableEnforceFocus: true }}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            eventEmitter.emit("closeAllDrawers");
          } else {
            onClose();
          }
        }}
        PaperProps={{
          sx: {
            width: isExpanded ? "100%" : "50%",
            transition: "width 0.3s ease",
            bgcolor: theme.palette.mode === "dark" ? "#1E1E1E" : "#FFFFFF",
            borderLeft: `1px solid ${theme.palette.mode === "dark" ? "#2D2D2D" : "#E5E7EB"
              }`,
            overflow: "hidden"
          },
        }}
      >
        {isLoading ? (
          <Box
            sx={{
              // display: 'flex',
              // justifyContent: 'center',
              // alignItems: 'center',
              height: "100%",
              // flexDirection: 'column',
              // gap: 2
            }}
          >
            <SkeletonLoader
              count={Math.floor(window.innerHeight / 40)}
              styles={{ height: 30 }}
            />
            {/* <CircularProgress />
                        <Typography variant="body1">Loading asset details...</Typography> */}
          </Box>
        ) : (
          <>
            <Box
              className="no-drag"
              sx={{
                position: "sticky",
                top: 0,
                zIndex: 2,
                bgcolor: theme.palette.mode === "dark" ? "#1E1E1E" : "#FFFFFF",
              }}
            >
              {/* Header */}
              <Box
                sx={{
                  px: 2,
                  pt: 0.5,
                  pb: 0,
                  borderBottom: `1px solid ${theme.palette.mode === "dark" ? "#2D2D2D" : "#E5E7EB"
                    }`,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    mb: 0.5,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    {/* <Box
                                            component="img"
                                            src={
                                                assetData?.vendor?.toLowerCase() === 'cisco' ? cisco_assets :
                                                assetData?.vendor?.toLowerCase() === 'arista' ? arista_assets :
                                                assetData?.vendor?.toLowerCase() === 'paloalto' ? paloalto_assets :
                                                `/assets/vendor-logos/${assetData?.vendor?.toLowerCase()}.png`
                                            }
                                            alt={assetData?.vendor}
                                            sx={{ 
                                                width: 40, 
                                                height: 40,
                                                objectFit: 'contain'
                                            }}
                                        /> */}
                    <Box>
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1.5 }}
                      >
                        {(() => {
                          const v = (assetData?.vendor || "").toLowerCase();
                          const c = (assetData?.cloud || "").toLowerCase();
                          let logoSrc: string | null = null;
                          if (v.includes("cisco")) logoSrc = isDarkMode ? cisco_dark : cisco_assets;
                          else if (v.includes("fortinet")) logoSrc = isDarkMode ? fortinet_scan_dark : fortinet_img;
                          else if (v.includes("arista")) logoSrc = isDarkMode ? arista_dark : arista_assets;
                          else if (v.includes("palo alto") || v.includes("paloalto")) logoSrc = isDarkMode ? paloalto_dark : paloalto_assets;
                          else if (v.includes("juniper")) logoSrc = isDarkMode ? juniper_dark : juniperLogo;
                          else if (v.includes("sophos")) logoSrc = isDarkMode ? sophos_dark : sophosLogo;
                          else if (c.includes("amazon") || v.includes("amazon")) logoSrc = isDarkMode ? aswdarklogo : aswlogo;
                          else if (c.includes("ubuntu") || v.includes("ubuntu")) logoSrc = isDarkMode ? ubuntu_dark : ubuntu_light;
                          else if (v.includes("debian")) logoSrc = isDarkMode ? debian_dark : debian;
                          else if (v.includes("microsoft") || v.includes("windows")) logoSrc = isDarkMode ? windows_dark : windows_light;
                          else if (v.includes("redhat")) logoSrc = isDarkMode ? redhat_dark : redhat_light;
                          else if (v.includes("huawei")) logoSrc = isDarkMode ? huawei_dark : huawei_light;
                          else if (v.includes("mikrotik")) logoSrc = isDarkMode ? mikrotik_dark : mikrotik;
                          else if (v.includes("edgecore")) logoSrc = edgecore_logo;
                          else if (v.includes("tp-link") || v.includes("tplink")) logoSrc = isDarkMode ? tplink_dark : tplink_light;
                          else if (v.includes("apple") || v.includes("mac")) logoSrc = isDarkMode ? apple_dark : apple_img;
                          else if (v.includes("dell")) logoSrc = dell_logo;
                          else if (v.includes("syrotech")) logoSrc = isDarkMode ? syrotech_dark : syrotech_light;

                          if (!logoSrc) return null;

                          return (
                            <Box
                              component="img"
                              src={logoSrc}
                              alt={assetData?.vendor || "Vendor"}
                              onError={(e: any) => {
                                e.currentTarget.style.display = "none";
                              }}
                              sx={{
                                height: 32,
                                maxWidth: 110,
                                objectFit: "contain",
                                flexShrink: 0,
                              }}
                            />
                          );
                        })()}

                        {(() => {
                          const baseName = assetData?.device_name || assetData?.resource_name || "";
                          const deviceType = (assetData as any)?.device_type || summaryData?.device_type;
                          const model = (assetData as any)?.model || summaryData?.model;
                          let displayTitle = baseName;
                          if (deviceType && model) displayTitle = `${baseName}(${deviceType}-${model})`;
                          else if (deviceType) displayTitle = `${baseName}(${deviceType})`;
                          else if (model) displayTitle = `${baseName}(${model})`;

                          return (
                            <Tooltip title={displayTitle} arrow>
                              <Typography
                                variant="h6"
                                sx={{
                                  fontWeight: 700,
                                  fontSize: 16,
                                  maxWidth: 400,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {displayTitle}
                              </Typography>
                            </Tooltip>
                          );
                        })()}
                        {/* <Typography
                          variant="body2"
                          sx={{ color: "text.secondary" }
                        >
                          •
                        </Typography> */}
                        {/* <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: 600,
                            color: "text.secondary",
                          }}
                        >
                          {assetData?.device_type}
                        </Typography> */}
                        {hasPermissions(
                          ROLES_CONTENT_PROPS.DOWNLOAD_REPORT
                        ) && (
                            <>
                              {/* <IconButton size="small">
                              <MoreVertIcon fontSize="small" />
                            </IconButton> */}
                              {assetData?.type !== "cloud" && !isDiscovery && isMenu}
                              <Tooltip title={isExpanded ? "Compress" : "Expand"} placement="bottom">
                                <IconButton size="small" onClick={() => setIsExpanded(!isExpanded)}>
                                  {isExpanded ? (
                                    <FaCompressAlt
                                      size={16}
                                      color={theme.palette.mode === "dark" ? "#9CA3AF" : "#475467"}
                                    />
                                  ) : (
                                    <FaExpandAlt
                                      size={16}
                                      color={theme.palette.mode === "dark" ? "#9CA3AF" : "#475467"}
                                    />
                                  )}
                                </IconButton>
                              </Tooltip>
                              <Tooltip
                                title={
                                  isDiscovery
                                    ? "Report download is not available for discovery assets"
                                    : "Download Report"
                                }
                                placement="bottom"
                              >
                                <span>
                                  <IconButton
                                    size="small"
                                    disabled={isDiscovery}
                                    onClick={() => setDownloadModalOpen(true)}
                                    sx={{
                                      "&.Mui-disabled": {
                                        opacity: 0.4,
                                        cursor: "not-allowed",
                                      },
                                    }}
                                  >
                                    <DownloadIcon
                                      fontSize="small"
                                      sx={{
                                        color: isDiscovery
                                          ? theme.palette.mode === "dark"
                                            ? "#6B7280"
                                            : "#9CA3AF"
                                          : theme.palette.mode === "dark"
                                          ? "#fff"
                                          : "#0F02C3",
                                      }}
                                    />
                                  </IconButton>
                                </span>
                              </Tooltip>
                            </>
                          )}
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          mt: 0,
                        }}
                      >
                        <Chip
                          label={assetData?.criticality}
                          size="small"
                          sx={{
                            bgcolor: getCriticalityColor(
                              assetData?.criticality
                            ),
                            color: "#fff",
                          }}
                        />
                        <Typography variant="caption" color="text.secondary">
                          {assetData?.region_name}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    {/* <IconButton
                      onClick={() => setChatDrawerOpen(true)}
                      size="small"
                      sx={{
                        "&:hover img": {
                          opacity: 1,
                        },
                      }}
                    >
                      <img
                        src={chat_icon}
                        alt="Chat"
                        style={{
                          width: 24,
                          height: 24,
                          opacity: 0.8,
                          transition: "opacity 0.2s",
                        }}
                      />
                    </IconButton> */}
                    <IconButton onClick={onClose} size="small">
                      <CloseIcon />
                    </IconButton>
                  </Box>
                  {/* <IconButton onClick={onClose} size="small">
                    <CloseIcon />
                  </IconButton> */}
                </Box>
              </Box>

              {/* Tabs / Select Dropdown based on V2 */}
              <Box
                sx={{
                  px: isAssetV2 ? 2 : 0,
                  py: isAssetV2 ? 0.5 : 0,
                  borderBottom: 1,
                  borderColor: "divider",
                  bgcolor:
                    theme.palette.mode === "dark" ? "#1E1E1E" : "#FFFFFF",
                }}
              >
                {isAssetV2 && !isExpanded ? (
                  <Select
                    value={tabValue}
                    onChange={(e: SelectChangeEvent<number>) => {
                      const newValue = Number(e.target.value);
                      if (newValue === 99) {
                        handleShowConfigDiff();
                        return;
                      }
                      setTabValue(newValue);
                      setCveDrawerOpen(false);
                      setMisconfigDrawerOpen(false);
                    }}
                    size="small"
                    sx={{
                      minWidth: 220,
                      borderRadius: "8px",
                      fontWeight: 700,
                      fontSize: "13px",
                      bgcolor: isDarkMode ? "#121212" : "#FFFFFF",
                      color: isDarkMode ? "#FFFFFF" : "#101828",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: isDarkMode ? "#333333" : "#D0D5DD",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: isDarkMode ? "#555555" : "#98A2B3",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: isDarkMode ? "#3B82F6" : "#4A7BF7",
                      },
                      "& .MuiSelect-select": {
                        py: 0.75,
                        px: 1.5,
                      },
                    }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          borderRadius: "8px",
                          mt: 0.5,
                          boxShadow: isDarkMode
                            ? "0px 4px 16px rgba(0,0,0,0.5)"
                            : "0px 4px 16px rgba(0,0,0,0.1)",
                          bgcolor: isDarkMode ? "#1A1A1A" : "#FFFFFF",
                          "& .MuiMenuItem-root": {
                            fontSize: "13px",
                            fontWeight: 600,
                            py: 1,
                            px: 2,
                            color: isDarkMode ? "#E5E7EB" : "#344054",
                            "&:hover": {
                              bgcolor: isDarkMode
                                ? "rgba(255,255,255,0.08)"
                                : "#F9FAFB",
                            },
                            "&.Mui-selected": {
                              bgcolor: isDarkMode
                                ? "rgba(59, 130, 246, 0.15)"
                                : "#F0F4FE",
                              color: isDarkMode ? "#60A5FA" : "#2563EB",
                              fontWeight: 700,
                            },
                          },
                        },
                      },
                    }}
                  >
                    {!isAssetV2 && <MenuItem value={0}>Summary</MenuItem>}
                    {!isAssetV2 && <MenuItem value={1}>{`Recommendations (${misconfigData.length})`}</MenuItem>}
                    {!isAssetV2 && isCve && <MenuItem value={2}>{`CVE's (${cveData.length})`}</MenuItem>}
                    {!isAssetV2 && <MenuItem value={isCve ? 3 : 2}>Compliance</MenuItem>}

                    {isAssetV2 && isCloud && <MenuItem value={0}>Summary</MenuItem>}
                    {isAssetV2 && isCloud && <MenuItem value={1}>{`Recommendations (${misconfigData.length})`}</MenuItem>}
                    {isAssetV2 && isCloud && <MenuItem value={isCve ? 3 : 2}>Compliance</MenuItem>}

                    {isAssetV2 && !isCloud && <MenuItem value={-1}>Summary</MenuItem>}
                    {isAssetV2 && !isCloud && <MenuItem value={104}>{historyData.length > 0 ? `History (${historyData.length})` : "History"}</MenuItem>}
                    {isAssetV2 && !isCloud && <MenuItem value={0}>Security Posture</MenuItem>}
                    {isAssetV2 && !isCloud && <MenuItem value={1}>{`Recommendations (${misconfigData.length})`}</MenuItem>}
                    {isAssetV2 && !isCloud && isCve && (
                      <MenuItem value={2}>{`CVE's (${cveData.length})`}</MenuItem>
                    )}
                    {isAssetV2 && !isCloud && <MenuItem value={isCve ? 3 : 2}>Compliance</MenuItem>}
                    {isAssetV2 && !isCloud && showSoftwareInfo && (
                      <MenuItem value={101}>
                        {softwareData.length > 0 ? `Software (${softwareData.length})` : "Software"}
                      </MenuItem>
                    )}
                    {isAssetV2 && !isCloud && (
                      <MenuItem value={102}>
                        {usersData.length > 0 ? `Users (${usersData.length})` : "Users"}
                      </MenuItem>
                    )}
                    {isAssetV2 && !isCloud && (
                      <MenuItem value={103}>
                        {credentialsData.length > 0 ? `Credentials (${credentialsData.length})` : "Credentials"}
                      </MenuItem>
                    )}
                    {isAssetV2 && !isCloud &&
                      assetData?.device_type?.toLowerCase() !== "endpoint" &&
                      assetData?.type?.toLowerCase() !== "discovery" &&
                      (assetData as any)?.scan_type?.toLowerCase() !== "discovery" && (
                        <MenuItem value={99}>Show Config Diff</MenuItem>
                      )}
                    {isAssetV2 && !isCloud && (assetData as any)?.discovery_ports?.length > 0 && (
                      <MenuItem value={100}>{`Ports (${(assetData as any).discovery_ports.length})`}</MenuItem>
                    )}
                  </Select>
                ) : (
                  <Tabs value={tabValue} onChange={handleTabChange} variant="scrollable" scrollButtons="auto">
                    {!isAssetV2 && <Tab sx={{ fontWeight: 800, fontSize: 13 }} label="Summary" value={0} />}
                    {!isAssetV2 && (
                      <Tab
                        sx={{ fontWeight: 800, fontSize: 13 }}
                        label={`Recommendations (${misconfigData.length})`}
                        value={1}
                      />
                    )}
                    {!isAssetV2 && isCve && (
                      <Tab
                        sx={{ fontWeight: 800, fontSize: 13 }}
                        label={`CVE's (${cveData.length})`}
                        value={2}
                      />
                    )}
                    {!isAssetV2 && (
                      <Tab
                        sx={{ fontWeight: 800, fontSize: 13 }}
                        label="Compliance"
                        value={isCve ? 3 : 2}
                      />
                    )}

                    {isAssetV2 && isCloud && <Tab sx={{ fontWeight: 800, fontSize: 13 }} label="Summary" value={0} />}
                    {isAssetV2 && isCloud && (
                      <Tab
                        sx={{ fontWeight: 800, fontSize: 13 }}
                        label={`Recommendations (${misconfigData.length})`}
                        value={1}
                      />
                    )}
                    {isAssetV2 && isCloud && (
                      <Tab
                        sx={{ fontWeight: 800, fontSize: 13 }}
                        label="Compliance"
                        value={isCve ? 3 : 2}
                      />
                    )}

                    {isAssetV2 && !isCloud && <Tab sx={{ fontWeight: 800, fontSize: 13 }} label="Summary" value={-1} />}
                    {isAssetV2 && !isCloud && <Tab sx={{ fontWeight: 800, fontSize: 13 }} label={historyData.length > 0 ? `History (${historyData.length})` : "History"} value={104} />}
                    {isAssetV2 && !isCloud && <Tab sx={{ fontWeight: 800, fontSize: 13 }} label="Security Posture" value={0} />}
                    {isAssetV2 && !isCloud && (
                      <Tab
                        sx={{ fontWeight: 800, fontSize: 13 }}
                        label={`Recommendations (${misconfigData.length})`}
                        value={1}
                      />
                    )}
                    {isAssetV2 && !isCloud && isCve && (
                      <Tab
                        sx={{ fontWeight: 800, fontSize: 13 }}
                        label={`CVE's (${cveData.length})`}
                        value={2}
                      />
                    )}
                    {isAssetV2 && !isCloud && (
                      <Tab
                        sx={{ fontWeight: 800, fontSize: 13 }}
                        label="Compliance"
                        value={isCve ? 3 : 2}
                      />
                    )}
                    {isAssetV2 && !isCloud && showSoftwareInfo && (
                      <Tab
                        sx={{ fontWeight: 800, fontSize: 13 }}
                        label={softwareData.length > 0 ? `Software (${softwareData.length})` : "Software"}
                        value={101}
                      />
                    )}
                    {isAssetV2 && !isCloud && (
                      <Tab
                        sx={{ fontWeight: 800, fontSize: 13 }}
                        label={usersData.length > 0 ? `Users (${usersData.length})` : "Users"}
                        value={102}
                      />
                    )}
                    {isAssetV2 && !isCloud && (
                      <Tab
                        sx={{ fontWeight: 800, fontSize: 13 }}
                        label={credentialsData.length > 0 ? `Credentials (${credentialsData.length})` : "Credentials"}
                        value={103}
                      />
                    )}
                    {isAssetV2 && !isCloud &&
                      assetData?.device_type?.toLowerCase() !== "endpoint" &&
                      assetData?.type?.toLowerCase() !== "discovery" &&
                      (assetData as any)?.scan_type?.toLowerCase() !== "discovery" && (
                        <Tab
                          sx={{ fontWeight: 800, fontSize: 13 }}
                          label="Show Config Diff"
                          value={99}
                        />
                      )}
                    {isAssetV2 && !isCloud && (assetData as any)?.discovery_ports?.length > 0 && (
                      <Tab
                        sx={{ fontWeight: 800, fontSize: 13 }}
                        label={`Ports (${(assetData as any).discovery_ports.length})`}
                        value={100}
                      />
                    )}
                  </Tabs>
                )}
              </Box>
            </Box>

            {/* Tab Panels */}
            <Box>
              <TabPanel value={tabValue} index={-1}>
                <Box sx={{ p: 1, overflow: "auto", height: "calc(100vh - 180px)" }} className="scroll">
                  {isSummaryLoading ? (
                    <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}><CircularProgress /></Box>
                  ) : summaryData ? (
                    <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: 1, boxShadow: "none" }}>
                      <Table sx={{ "& .MuiTableCell-root": { borderBottom: `1px solid ${theme.palette.divider}` } }}>
                        <TableBody>
                          {(() => {
                            const v = (summaryData.vendor || (assetData as any)?.vendor || "").toLowerCase();
                            const m = (summaryData.model || (assetData as any)?.model || "").toLowerCase();
                            const os = (summaryData.os_version || (assetData as any)?.os || "").toLowerCase();
                            const isMicrosoftOrWindows = v.includes("microsoft") || v.includes("windows") || m.includes("windows") || os.includes("windows") || os.includes("microsoft");
                            const isAppleOrMac = v.includes("apple") || v.includes("mac") || m.includes("mac") || os.includes("mac") || os.includes("apple");
                            const showSoftwareInfo = isMicrosoftOrWindows || isAppleOrMac;

                            const isDiscovery =
                              ((assetData as any)?.type || "").toLowerCase() === "discovery" ||
                              ((assetData as any)?.scan_type || "").toLowerCase() === "discovery" ||
                              (summaryData.type || "").toLowerCase() === "discovery" ||
                              (summaryData.scan_type || "").toLowerCase() === "discovery";

                            const isZeroOrEmpty = (val: any) => {
                              if (val === undefined || val === null || val === "" || val === "-") return true;
                              const num = Number(val);
                              return !isNaN(num) && num === 0;
                            };

                            const formatSummaryValue = (val: any) => {
                              if (val === undefined || val === null || val === "" || val === "-") return "-";
                              if (isDiscovery && isZeroOrEmpty(val)) return "-";
                              return val;
                            };

                            return [
                              { label: "Name", value: summaryData.name || "-" },
                              { label: "IP", value: summaryData.ip || "-" },
                              { label: "Vendor", value: summaryData.vendor ? <Chip label={summaryData.vendor} size="small" sx={{ bgcolor: theme.palette.mode === "dark" ? "rgba(99, 102, 241, 0.15)" : "#EEF2FF", color: theme.palette.mode === "dark" ? "#818CF8" : "#4F46E5", borderRadius: "6px", fontWeight: 600, fontSize: "12px", height: 24, px: 1, "& .MuiChip-label": { px: 1 } }} /> : "-" },
                              { label: "Model", value: summaryData.model || "-" },
                              { label: "Type", value: summaryData.device_type || summaryData.type || "-" },
                              { label: "OS Version", value: summaryData.os_version || "-" },
                              { label: "Last Detected", value: summaryData.last_detected ? moment(summaryData.last_detected).format("DD MMMM YYYY") : "-" },
                              { label: "CVE", value: formatSummaryValue(summaryData.cve), color: "#F59E0B" },
                              ...(showSoftwareInfo ? [{ label: "Software", value: formatSummaryValue(summaryData.software ?? (assetData as any)?.windows_software_count ?? (assetData as any)?.software_count) }] : []),
                              { label: "Score", value: formatSummaryValue(summaryData.score) },
                              { label: "Misconfiguration", value: formatSummaryValue(summaryData.misconfigurations?.failed_count) },
                              { label: "Open Ports", value: summaryData.ports?.length ?? "-" },
                            ];
                          })().map((row, idx, arr) => (
                            <TableRow 
                              key={idx} 
                              sx={{ 
                                "&:hover": { bgcolor: theme.palette.mode === "dark" ? "rgba(255,255,255,0.02)" : "#F9FAFB" },
                                "&:last-child td, &:last-child th": { borderBottom: 0 }
                              }}
                            >
                              <TableCell sx={{ 
                                fontWeight: 600, 
                                width: "30%", 
                                fontSize: "16px",
                                lineHeight: 2,
                                color: theme.palette.mode === "dark" ? "#9CA3AF" : "#4B5563", 
                                px: 10, 
                                py: 12,
                                verticalAlign: "middle",
                                borderRight: `1px solid ${theme.palette.divider}`
                              }}>
                                {row.label}
                              </TableCell>
                              <TableCell sx={{ 
                                color: (row.value !== "-" && row.color) ? row.color : (theme.palette.mode === "dark" ? "#F9FAFB" : "#111827"), 
                                fontWeight: (row.value !== "-" && row.color) ? 600 : 500, 
                                fontSize: "16px",
                                lineHeight: 2,
                                px: 10, 
                                py: 12,
                                verticalAlign: "middle",
                                borderRight: 0
                              }}>
                                {row.value}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  ) : (
                    <Typography align="center" sx={{ mt: 4 }}>No data available</Typography>
                  )}
                </Box>
              </TabPanel>
              <TabPanel value={tabValue} index={104}>
                <Box sx={{ width: "100%", overflowX: "auto" }}>
                  <AgGridTable
                    key={`history-${theme.palette.mode}`}
                    data={historyData}
                    columnDefs={historyColumnDefs}
                    isLoading={isHistoryLoading}
                    pagination={true}
                    showSearch={true}
                    searchPlaceholder="Search History..."
                    height="calc(100vh - 220px)"
                  />
                </Box>
              </TabPanel>
              <TabPanel value={tabValue} index={0}>
                <Box
                  sx={{ p: 1, overflow: "auto", height: "calc(100vh - 180px)" }}
                  className="scroll"
                >
                  <Grid container spacing={2}>
                    {/* First Grid - Score and Issues */}
                    <Grid item xs={6}>
                      {/* IntelliScore Card */}
                      <Paper
                        variant="outlined"
                        sx={{
                          p: 0.5,
                          mb: 2,
                        }}
                      >
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 0 }}
                        >
                          {/* <SecurityIcon sx={{ fontSize: 24 }} /> */}
                          <img
                            src={isDarkMode ? darklogo : Intelliscore}
                            alt=""
                          />
                        </Box>
                        <Box
                          sx={{
                            borderBottom: `1px solid ${theme.palette.divider}`,
                            // pb: 1,
                            mb: 2,
                          }}
                        />
                        <Box sx={{ display: "flex", p: 1 }}>
                          {/* Main Score */}
                          <Box
                            sx={{
                              flex: 1,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              borderRight: `1px solid ${theme.palette.divider}`,
                            }}
                          >
                            <Box
                              sx={{
                                width: 110,
                                height: 110,
                                position: "relative",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  height: "100%",
                                  width: "100%",
                                }}
                              >
                                <OnPremCircle
                                  score={Math.round(
                                    securityScoreData?.intelli_score ?? 0
                                  )}
                                />
                              </Box>
                            </Box>
                          </Box>
                          {!isCloud && (
                            <Box
                              sx={{
                                flex: 1,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                pl: 2,
                              }}
                            >
                              {/* Posture Score */}
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 2,
                                  pb: 2,
                                  mb: 2,
                                  borderBottom: `1px solid ${theme.palette.divider}`,
                                }}
                              >
                                <Box
                                  sx={{
                                    position: "relative",
                                    width: 50,
                                    height: 50,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  {/* <CircularProgress
                                                                variant="determinate"
                                                                value={100}
                                                                size={50}
                                                                thickness={3}
                                                                sx={{
                                                                    position: 'absolute',
                                                                    color: theme.palette.mode === 'dark' ? '#424242' : '#E3F2FD'
                                                                }}
                                                            />
                                                            <CircularProgress
                                                                variant="determinate"
                                                                value={15}
                                                                size={50}
                                                                thickness={3}
                                                                sx={{
                                                                    position: 'absolute',
                                                                    color: '#4F46E5',
                                                                    transform: 'rotate(180deg)',
                                                                    circle: {
                                                                        strokeLinecap: 'round'
                                                                    }
                                                                }}
                                                            />
                                                            <Typography variant="h6" sx={{ fontWeight: 600, zIndex: 1 }}>
                                                                {securityScoreData?.security_Score ? Math.round(securityScoreData.security_Score) : 0}
                                                            </Typography> */}
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      height: "100%",
                                      width: "100%",
                                    }}
                                  >
                                    <CircleChart
                                      score={Math.round(
                                        securityScoreData?.security_Score ?? 0
                                      )}
                                    />
                                  </Box>
                                </Box>
                                <Typography
                                  variant="subtitle1"
                                  sx={{ fontWeight: 500 }}
                                >
                                  Posture Score
                                </Typography>
                              </Box>

                              {/* CVE Score */}
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 2,
                                  pt: 0,
                                }}
                              >
                                <Box
                                  sx={{
                                    position: "relative",
                                    width: 50,
                                    height: 50,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  {/* <CircularProgress
                                                                variant="determinate"
                                                                value={100}
                                                                size={50}
                                                                thickness={3}
                                                                sx={{
                                                                    position: 'absolute',
                                                                    color: theme.palette.mode === 'dark' ? '#424242' : '#FFF3E0'
                                                                }}
                                                            />
                                                            <CircularProgress
                                                                variant="determinate"
                                                                value={58}
                                                                size={50}
                                                                thickness={3}
                                                                sx={{
                                                                    position: 'absolute',
                                                                    color: '#FF9800',
                                                                    transform: 'rotate(180deg)',
                                                                    circle: {
                                                                        strokeLinecap: 'round'
                                                                    }
                                                                }}
                                                            />
                                                            <Typography variant="h6" sx={{ fontWeight: 600, zIndex: 1 }}>
                                                                {securityScoreData?.cve_score ? Math.round(securityScoreData.cve_score) : 0}
                                                            </Typography> */}
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      height: "100%",
                                      width: "100%",
                                    }}
                                  >
                                    <CircleChart
                                      score={Math.round(
                                        securityScoreData?.cve_score ?? 0
                                      )}
                                    />
                                  </Box>
                                </Box>
                                <Typography
                                  variant="subtitle1"
                                  sx={{ fontWeight: 500 }}
                                >
                                  CVE Score
                                </Typography>
                              </Box>
                            </Box>
                          )}
                          {/* Right Side Scores */}
                        </Box>
                      </Paper>

                      {/* Issues Card */}
                      <Paper
                        variant="outlined"
                        sx={{
                          p: 1,
                        }}
                      >
                        <Typography
                          variant="subtitle1"
                          sx={{ fontWeight: 600, mb: 0, fontSize: "13px" }}
                        >
                          Issues
                        </Typography>
                        <Box
                          sx={{
                            borderBottom: `1px solid ${theme.palette.divider}`,
                            pb: 0.5,
                            mb: 2,
                          }}
                        />
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "flex-end",
                            gap: 4,
                          }}
                        >
                          {/* Misconfiguration */}

                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              width: 120,
                            }}
                          >
                            <Box
                              sx={{
                                width: 120,
                                height: 120,
                                position: "relative",
                                mb: -3,
                              }}
                            >
                              <ReactApexChart
                                options={chartMisOptions}
                                series={chartMisSeries}
                                type="donut"
                                height={120}
                                width={120}
                              />
                              <Box
                                sx={{
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  transform: "translate(-50%, -60%)",
                                  textAlign: "center",
                                  pointerEvents: "none",
                                }}
                              >
                                <Typography
                                  variant="h5"
                                  sx={{
                                    fontWeight: 700,
                                    color: "text.primary",
                                  }}
                                >
                                  {overAllVulnerbailityTotal || 0}
                                </Typography>
                              </Box>
                            </Box>
                            <Typography
                              variant="body2"
                              // color="text.secondary"
                              sx={{
                                mt: 0,
                                lineHeight: 1,
                                fontWeight: 700,
                                fontSize: "12px",
                              }}
                            >
                              Misconfiguration
                            </Typography>
                          </Box>

                          {/* Vulnerabilities */}
                          {!isCloud && (
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                width: 120,
                              }}
                            >
                              <Box
                                sx={{
                                  width: 120,
                                  height: 120,
                                  position: "relative",
                                  mb: -3,
                                }}
                              >
                                <ReactApexChart
                                  options={cveOptions}
                                  series={cveSeriesFinal}
                                  type="donut"
                                  height={120}
                                  width={120}
                                />
                                <Box
                                  sx={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -60%)",
                                    textAlign: "center",
                                    pointerEvents: "none",
                                  }}
                                >
                                  <Typography
                                    variant="h5"
                                    sx={{
                                      fontWeight: 700,
                                      color: "text.primary",
                                    }}
                                  >
                                    {cveVulnerability?.count || 0}
                                  </Typography>
                                </Box>
                              </Box>
                              <Typography
                                variant="body2"
                                // color="text.secondary"
                                sx={{
                                  mt: 0,
                                  lineHeight: 1,
                                  fontWeight: 700,
                                  fontSize: "12px",
                                }}
                              >
                                Vulnerabilities
                              </Typography>
                            </Box>
                          )}
                          {/* {module == 'on_premise' && cveVulnerability?.count === 0 && overAllVulnerbailityTotal === 0 && (
                                                 <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: 120 }}>
                                                   No Data
                                                 </Box>
                                                )}
                                                 {overAllVulnerbailityTotal === 0 && (
                                                 <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: 120 }}>
                                                   No Data
                                                 </Box>
                                                )} */}
                        </Box>
                      </Paper>
                    </Grid>

                    {/* Second Grid - Compliance */}
                    <Grid item xs={6}>
                      <Paper
                        variant="outlined"
                        sx={{
                          p: 1,
                          height: "100%",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            // mb: 1,
                          }}
                        >
                          <Typography
                            variant="subtitle1"
                            sx={{ fontWeight: "bold", fontSize: "13px" }}
                          >
                            Compliance :{" "}
                            {complianceData?.data?.compliance_data &&
                              Object.keys(complianceData.data.compliance_data)
                                .length > 0
                              ? Object.keys(complianceData.data.compliance_data)
                                .length
                              : 0}
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            borderBottom: `1px solid ${theme.palette.divider}`,
                            pb: 1,
                            mb: 2,
                          }}
                        />
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                            width: "100%",
                            height: "100%",
                          }}
                        >
                          {complianceData?.data?.compliance_data &&
                            Object.keys(complianceData.data.compliance_data)
                              .length > 0 ? (
                            Object.entries(
                              complianceData.data.compliance_data
                            ).map(([name, score]) => (
                              <Box key={name}>
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    mb: 0.5,
                                  }}
                                >
                                  <Typography
                                    variant="body2"
                                    sx={{ fontWeight: 600 }}
                                  >
                                    {name.replace("_", " ")}
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    sx={{ fontWeight: 800 }}
                                    color="#4366E1"
                                  >
                                    {Math.round(score)}%
                                  </Typography>
                                </Box>
                                <Box
                                  sx={{
                                    width: "100%",
                                    height: 4,
                                    bgcolor: "#E0E0E0",
                                    borderRadius: 2,
                                  }}
                                >
                                  <Box
                                    sx={{
                                      width: `${score}%`,
                                      height: "100%",
                                      bgcolor: "primary.main",
                                      borderRadius: 2,
                                    }}
                                  />
                                </Box>
                              </Box>
                            ))
                          ) : (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "80%",
                                width: "100%",
                              }}
                            >
                              <Typography variant="body2" color="textSecondary">
                                No compliance data available for this asset.
                              </Typography>
                            </Box>
                          )}
                        </Box>
                      </Paper>
                    </Grid>

                    {/* Third Grid - Asset Overview */}
                    {/* <Grid item xs={12}>
                                        <Paper sx={{ p: 2 }}>
                                            <Typography variant="h6" sx={{ mb: 2 }}>Asset Overview</Typography>
                                            <Grid container spacing={2}>
                                                <Grid item xs={6}>
                                                    <Typography variant="subtitle2" color="textSecondary">Total Vulnerabilities</Typography>
                                                    <Typography variant="h4">{assetData?.vulnerability || 0}</Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Typography variant="subtitle2" color="textSecondary">Total CVE's</Typography>
                                                    <Typography variant="h4">{assetData?.cve || 0}</Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Typography variant="subtitle2" color="textSecondary">Last Updated</Typography>
                                                    <Typography variant="body1">
                                                        {assetData?.cve_last_modified ? moment(assetData.cve_last_modified).format('DD MMM, YYYY HH:mm') : '-'}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Typography variant="subtitle2" color="textSecondary">Status</Typography>
                                                    <Chip 
                                                        label={assetData?.status === 1 ? "Active" : "Inactive"} 
                                                        color={assetData?.status === 1 ? "success" : "error"}
                                                        size="small"
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid> */}

                    {/* Fourth Grid - CyberResilienceView™ */}
                    <Grid item xs={12}>
                      <Paper sx={{ p: 2 }}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            mb: 2,
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 2,
                            }}
                          >
                            <Box
                              component="img"
                              src={
                                isDarkMode
                                  ? cyberResilienceViewsDark
                                  : cyberResilienceViews
                              }
                              alt="CyberResilienceView™"
                              sx={{ height: 36 }}
                            />
                          </Box>
                          <Box>
                            <Select
                              size="small"
                              value={timeRange}
                              onChange={handleTimeRangeChange}
                              sx={{ minWidth: 120 }}
                            >
                              <MenuItem value="7">Last 7 Days</MenuItem>
                              <MenuItem value="30">Last 30 Days</MenuItem>
                              <MenuItem value="90">Last 90 Days</MenuItem>
                            </Select>
                          </Box>
                        </Box>
                        <Box sx={{ height: 300, position: "relative" }}>
                          {isChartLoading ? (
                            // Show skeleton loader while loading
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "100%",
                                gap: 2,
                              }}
                            >
                              <CircularProgress size={32} />
                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >

                              </Typography>
                            </Box>
                          ) : (
                            // Show chart container only when not loading
                            <>
                              <TimelineChart cyberGraphData={cyberGraphData} isCloud={isCloud} timeRange={timeRange} />

                            </>

                          )}
                        </Box>
                      </Paper>
                    </Grid>
                  </Grid>
                </Box>
              </TabPanel>

              <TabPanel value={tabValue} index={1}>
                {/* <Typography variant="h6" sx={{ mb: 2 }}>Misconfigurations</Typography> */}
                {!misconfigDrawerOpen ? (
                  <>
                    <AgGridTable
                      data={misconfigData}
                      columnDefs={misconfigColumnDefs}
                      isLoading={misconfigLoading}
                      styles={agGridInlineStyles}
                      pagination={true}
                      showSearch={true}
                      onRowClick={handleMisconfigClick}
                      gridOptions={memoizedGridOptions}
                      height="calc(100vh - 220px)"
                      mandatoryColumns={["Recommendation"]}
                    />
                  </>
                ) : (
                  <>
                    <Box
                      sx={{
                        p: 1,
                        width: "100%",
                        maxWidth: isExpanded ? "100%" : 800,
                        borderRadius: 2,
                        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          mb: 3,
                          flexDirection: "row",
                        }}
                      >
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              gap: 2,
                              alignItems: "center",
                            }}
                          >
                            {misconfigDrawerOpen && (
                              <IconButton
                                onClick={() => setMisconfigDrawerOpen(false)}
                                sx={{ mr: 1, p: "8px 8px 8px 0px" }}
                              >
                                <ArrowBackIcon />
                              </IconButton>
                            )}
                            <Typography
                              variant="h6"
                              fontWeight="bold"
                              sx={{ mr: 3 }}
                            >
                              {selectedMisconfig?.param_name}
                            </Typography>
                          </div>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 2,
                              mb: 3,
                            }}
                          >
                            <Chip
                              label={selectedMisconfig.severity}
                              size="small"
                              sx={{
                                bgcolor:
                                  severityStyles[selectedMisconfig.severity]
                                    ?.bgcolor || "#f5f5f5",
                                color:
                                  severityStyles[selectedMisconfig.severity]
                                    ?.color || "#666666",
                                height: "20px",
                                borderRadius: "4px",
                                position: "relative",
                                fontWeight: 600,
                                p: 1.5,
                                pr: 0,
                                "&::before": {
                                  content: '""',
                                  position: "absolute",
                                  left: 8,
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  width: 8,
                                  height: 8,
                                  bgcolor:
                                    severityStyles[selectedMisconfig.severity]
                                      ?.color || "#666666",
                                  borderRadius: "50%",
                                },
                                "& .MuiChip-label": { px: 1 },
                              }}
                            />
                            <Divider orientation="vertical" flexItem />
                            {true && (
                              <>
                                <Typography
                                  variant="h6"
                                  sx={{ fontWeight: 700, ml: 3, fontSize: 12 }}
                                >
                                  Accepted Risk:
                                </Typography>
                                {selectedMisconfig.accepted_count && (
                                  <img
                                    src={Exclamation}
                                    alt="Accepted"
                                    style={{ width: 24, height: 24 }}
                                  />
                                )}
                              </>
                            )}

                            <Divider orientation="vertical" flexItem />
                            <Typography
                              variant="h6"
                              sx={{ fontWeight: 700, fontSize: 12 }}
                            >
                              Status:
                            </Typography>
                            {selectedMisconfig.compliance ? (
                              <img
                                src={Config_Tick}
                                alt="Accepted"
                                style={{ width: 24, height: 24 }}
                              />
                            ) : (
                              <img
                                src={Failed_img}
                                alt="Accepted"
                                style={{ width: 24, height: 24 }}
                              />
                            )}

                            {/* <Typography
          variant="h6"
          sx={{ fontWeight: 700, ml: 3, fontSize: 12 }}
        >
          Last Scanned:
        </Typography>
        <Typography>{lastScanned}</Typography> */}
                          </Box>
                        </div>
                      </Box>
                      <DetailsFlyout
                        Total_Resources={0}
                        id={selectedMisconfig?.id}
                        isTotal={false}
                        module={isCloud ? "cloud" : "on_premise"}
                        parameterType={selectedMisconfig?.parameter_type || selectedMisconfig?.parameter_type_id}
                      />
                    </Box>
                  </>
                )}
              </TabPanel>

              {isCve && (
                <TabPanel value={tabValue} index={2}>
                  {/* <Paper sx={{ p: 2 }}> */}
                  {/* <Typography variant="h6" sx={{ mb: 2 }}>CVE's</Typography> */}
                  <div>
                    <AgGridTable
                      key={isDarkMode ? 'dark' : 'light'}
                      data={cveData}
                      columnDefs={columnDefs}
                      isLoading={loading}
                      onRowClick={handleCVEClick}
                      pagination={true}
                      showSearch={true}
                      height="calc(100vh - 200px)"
                    />
                  </div>

                  {selectedCVE && (
                    <CVEDetailsDrawer
                      open={cveDrawerOpen}
                      onClose={() => setCveDrawerOpen(false)}
                      cveData={{
                        cve_id: selectedCVE.cve_id,
                        severity: selectedCVE.severity,
                        cvss_score: parseFloat(selectedCVE.score),
                        affected_assets: selectedCVE.asset_count,
                        summaryData: selectedCVE.summaryData,
                        cisa_key: selectedCVE.cisas_kev,
                      }}
                      isLoading={isCveLoading}
                      isNavigationFromAssets={false}
                    />
                  )}
                  {/* </Paper> */}
                </TabPanel>
              )}

              <TabPanel value={tabValue} index={isCve ? 3 : 2}>
                {/* <Paper sx={{ p: 2 }}> */}
                <CveComplience assetDetails={assetData} />
                {/* <Typography variant="h6" sx={{ mb: 2 }}>Compliance</Typography>
                                    <Typography variant="body2" color="textSecondary">
                                        No compliance data available for this asset.
                                    </Typography> */}
                {/* </Paper> */}
              </TabPanel>

              <TabPanel value={tabValue} index={99}>
                <Box
                  sx={{ p: 1, overflow: "auto", height: "calc(100vh - 180px)" }}
                  className="scroll"
                >
                  {(() => {
                    const details = configDiffDetails || {};
                    const asset = assetData as any;
                    const name = details.device_name || asset?.device_name || "-";
                    const vendor = details.vendor || asset?.vendor || "-";
                    const model = details.model || asset?.model;
                    const type = details.device_type || asset?.device_type || "-";
                    const version = details.device_version || "-";
                    const region = details.region_name || asset?.region_name || "Unassigned";
                    const criticality = details.criticality || asset?.criticality || "-";
                    const lastScan = details.last_scan_date
                      ? moment(details.last_scan_date).format("D MMM YYYY")
                      : "-";
                    const totalScans = details.total_scans ?? "-";
                    const deviceId = String(asset?.id || asset?.device_id || "");
                    const fields = [
                      { label: "Name", value: name },
                      { label: "Vendor", value: vendor },
                      { label: "OS, Type", value: model ? `${model} / ${type}` : "-" },
                      { label: "Version", value: version },
                      { label: "Region", value: region },
                      { label: "Criticality", value: criticality },
                      { label: "Last Scan Date", value: lastScan },
                      { label: "Total Scans", value: totalScans },
                    ];
                    return (
                      <>
                        <Box
                          sx={{
                            display: "flex",
                            gap: 2,
                            alignItems: "center",
                            flexWrap: "wrap",
                            width: "100%",
                            p: 2,
                            mb: 2,
                            border: "1px solid",
                            borderColor: "divider",
                            borderRadius: 2,
                            bgcolor: "background.paper",
                          }}
                        >
                          {fields.map((item) => (
                            <Box key={item.label} sx={{ minWidth: 120, flex: "1 1 auto", maxWidth: 200 }}>
                              <Typography variant="caption" sx={{ display: "block", fontWeight: 700 }}>
                                {item.label}
                              </Typography>
                              <Typography variant="body2" sx={{ color: "text.secondary", fontWeight: 700 }}>
                                {item.value ?? "-"}
                              </Typography>
                            </Box>
                          ))}
                        </Box>
                        <TrendsCard compact height={220} deviceId={deviceId} />
                        <Box sx={{ mt: 2 }}>
                          <AssetHistoryTable
                            height={320}
                            device_id={deviceId}
                            historyData={configDiffHistory}
                            page={configDiffPage}
                            pageSize={configDiffPageSize}
                            isLoading={isConfigDiffLoading}
                            vendor={details.vendor || asset?.vendor}
                            source="assets-page"
                            compact={!isExpanded}
                            onPageChange={(page, pageSize) => {
                              setConfigDiffPage(page);
                              setConfigDiffPageSize(pageSize);
                            }}
                          />
                        </Box>
                      </>
                    );
                  })()}
                </Box>
              </TabPanel>

              {/* Ports Tab Panel */}
              <TabPanel value={tabValue} index={100}>
                <AgGridTable
                  data={(assetData as any)?.discovery_ports || []}
                  columnDefs={portsColumnDefs}
                  isLoading={false}
                  styles={agGridInlineStyles}
                  pagination={true}
                  showSearch={true}
                  height="calc(100vh - 220px)"
                />
              </TabPanel>

              {/* Software Tab Panel */}
              <TabPanel value={tabValue} index={101}>
                <Box sx={{ width: "100%", overflowX: "auto" }}>
                  <AgGridTable
                    key={`software-${theme.palette.mode}`}
                    data={softwareData}
                    columnDefs={softwareColumnDefs}
                    isLoading={isSoftwareLoading}
                    pagination={true}
                    showSearch={true}
                    searchPlaceholder="Search Software..."
                    height="calc(100vh - 220px)"
                  />
                </Box>
              </TabPanel>

              {/* Users Tab Panel */}
              <TabPanel value={tabValue} index={102}>
                <Box sx={{ width: "100%", overflowX: "auto" }}>
                  <AgGridTable
                    key={`users-${theme.palette.mode}`}
                    data={usersData}
                    columnDefs={userOwnerColumnDefs}
                    isLoading={isUsersLoading}
                    pagination={true}
                    showSearch={true}
                    searchPlaceholder="Search Users..."
                    height="calc(100vh - 220px)"
                  />
                </Box>
              </TabPanel>

              {/* Credentials Tab Panel */}
              <TabPanel value={tabValue} index={103}>
                <Box sx={{ width: "100%", overflowX: "auto" }}>
                  <AgGridTable
                    key={`credentials-${theme.palette.mode}`}
                    data={credentialsData}
                    columnDefs={credentialsColumnDefs}
                    isLoading={isCredentialsLoading}
                    pagination={true}
                    showSearch={true}
                    searchPlaceholder="Search Credentials..."
                    height="calc(100vh - 220px)"
                  />
                </Box>
              </TabPanel>
            </Box>
          </>
        )}
      </Drawer>

      {/* Chat Drawer */}
      <Drawer
        anchor="right"
        open={chatDrawerOpen}
        onClose={() => {
          setChatDrawerOpen(false);
          setChatInput("");
          setChatResponse({
            status: 200,
            message: "Welcome",
            data: {
              result: "",
            },
          });
        }}
        sx={{
          "& .MuiDrawer-paper": {
            width: { xs: "100%", sm: "40%" },
            bgcolor:
              theme.palette.mode === "dark" ? "background.paper" : "white",
            boxShadow: "-4px 0 8px rgba(0, 0, 0, 0.1)",
          },
        }}
      >
        <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
          {/* Chat Header */}
          <Box
            sx={{
              p: 2,
              borderBottom: 1,
              borderColor: "divider",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <img
                src={chat_icon}
                alt="Chat"
                style={{ width: 24, height: 24 }}
              />
              <Typography variant="h6">
                Asset Configuration Assistant
              </Typography>
            </Box>
            <IconButton onClick={() => setChatDrawerOpen(false)} size="small">
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Chat Content */}
          <Box
            sx={{
              p: 2,
              flexGrow: 1,
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            {!chatResponse.data?.result ? (
              <Box sx={{ textAlign: "center", mt: 4 }}>
                <Typography variant="body1">
                  Hi, I can help you analyze the configuration of{" "}
                  {assetData?.device_name}. What would you like to know?
                </Typography>
              </Box>
            ) : (
              <Box
                sx={{
                  bgcolor:
                    theme.palette.mode === "dark"
                      ? "rgba(255, 255, 255, 0.05)"
                      : "rgba(0, 0, 0, 0.02)",
                  p: 2,
                  borderRadius: 1,
                  "& pre": {
                    margin: 0,
                    padding: 0,
                    fontFamily: "monospace",
                  },
                }}
              >
                {formatChatResponse(chatResponse.data.result)}
              </Box>
            )}
          </Box>

          {/* Chat Input */}
          <Box
            sx={{
              p: 2,
              borderTop: 1,
              borderColor: "divider",
              bgcolor:
                theme.palette.mode === "dark" ? "background.paper" : "grey.50",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                bgcolor:
                  theme.palette.mode === "dark"
                    ? "rgba(255, 255, 255, 0.05)"
                    : "#FFFFFF",
                borderRadius: 2,
                p: 1,
              }}
            >
              <TextField
                fullWidth
                placeholder="Ask about the configuration..."
                variant="standard"
                value={chatInput}
                onChange={(e) => setChatInput(e.target.value)}
                InputProps={{
                  disableUnderline: true,
                }}
              />
              <IconButton
                onClick={handleChatSubmit}
                disabled={isLoadingChat}
                size="small"
              >
                {isLoadingChat ? (
                  <CircularProgress size={20} />
                ) : (
                  <img
                    src={chat_send}
                    alt="Send"
                    style={{ width: 20, height: 20 }}
                  />
                )}
              </IconButton>
            </Box>
          </Box>
        </Box>
      </Drawer>

      {/* Report Drawer */}
      <Drawer
        anchor="right"
        open={reportDrawerOpen}
        onClose={() => setReportDrawerOpen(false)}
        PaperProps={{ sx: { width: 400, borderRadius: 2 } }}
      >
        <AssetComplianceReportDrawer
          onClose={() => setReportDrawerOpen(false)}
          assetData={assetData}
          isCloud={isCloud}
        />
      </Drawer>

      {/* Download Report Modal */}
      <Drawer
        anchor="right"
        open={downloadModalOpen}
        onClose={() => setDownloadModalOpen(false)}
        aria-labelledby="download-report-modal"
      >
        <Box
          sx={{
            position: 'relative',
            width: { xs: '100%', sm: 400 },
            bgcolor: 'background.paper',
            borderRadius: 2,
            p: 3,
            outline: 'none',
          }}
        >
          {/* Header */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              {isCloud ? "Resource Report" : "Asset Report"}
            </Typography>
            <IconButton
              onClick={() => setDownloadModalOpen(false)}
              size="small"
              sx={{ color: 'text.secondary' }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Report Format Selection */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
              Report Format
            </Typography>
            <RadioGroup
              value={reportFormat}
              onChange={(e) => setReportFormat(e.target.value)}
              sx={{ flexDirection: 'row', gap: 2 }}
            >
              <FormControlLabel
                value="pdf"
                control={<Radio />}
                label="Pdf"
                sx={{
                  '& .MuiFormControlLabel-label': {
                    fontSize: '14px',
                    fontWeight: 500,
                  },
                }}
              />
              <FormControlLabel
                value="excel"
                control={<Radio />}
                label="Excel"
                sx={{
                  '& .MuiFormControlLabel-label': {
                    fontSize: '14px',
                    fontWeight: 500,
                  },
                }}
              />
            </RadioGroup>
          </Box>

          {/* Download Button */}
          <Button
            fullWidth
            variant="contained"
            onClick={handleDownloadReport}
            disabled={downloadLoading}
            sx={{
              bgcolor: theme.palette.primary.main,
              color: 'white',
              py: 1.5,
              borderRadius: 2,
              fontWeight: 600,
              '&:hover': {
                bgcolor: theme.palette.primary.dark,
              },
            }}
          >
            {downloadLoading ? (
              <Box display="flex" alignItems="center" gap={1}>
                <CircularProgress size={20} sx={{ color: 'white' }} />
                <Typography sx={{ color: 'white', fontSize: '14px' }}>
                  Downloading Report...
                </Typography>
              </Box>
            ) : (
              'Download Report'
            )}
          </Button>
        </Box>
      </Drawer>
    </>
  );
};

export default AssetDetailsDrawer;
